

exports.__esModule = true;
exports.$xoReviewPageComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _uiRouter = require('uiRouter');

var _index = require('js/lib/index');

var _logger = require('xo-beaver/dist/logger');

var _integration = require('js/lib/integration');

var _index2 = require('xo-device-info/dist/index');

var _ul = require('xo-login-components/src/unified-login/ul');

var _pxp = require('xo-page-components/src/cart/lib/pxp');

var _marketingoffer = require('xo-models/src/marketingoffer/');

var _angular = require('angular');

var _kmliUpsell = require('xo-login-components/src/onetouch-interstitial/kmliUpsell');

var _utils = require('xo-member-components/src/rewards-checkbox/utils');

var _squid = require('squid');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _auth = require('xo-models/src/auth');

var _fiApis = require('xo-models/src/fi/lib/fiApis');

var _eligibility = require('xo-models/src/eligibility');

var _index3 = require('xo-models/src/fiMeta/index');

var _index4 = _interopRequireDefault(_index3);

var _choice = require('xo-models/src/choice');

var _fiMessages = require('xo-models/src/fi/lib/fiMessages');

var _donation = require('xo-models/src/donation');

var _bml = require('xo-models/src/bml');

var _credit = require('xo-models/src/credit');

var _fi = require('xo-models/src/fi');

var _app = require('xo-models/src/app');

var _checkout = require('xo-models/src/checkout');

var _experiments = require('xo-models/src/experiments');

var Experiments = _interopRequireWildcard(_experiments);

var _marketingoffer2 = require('xo-models/src/marketingoffer');

var _newMember = require('xo-models/src/newMember');

var _shippingMethod = require('xo-models/src/shippingMethod');

var _user = require('xo-models/src/user');

var _factory = require('xo-member-components/src/give-at-checkout/factory');

var _factory2 = require('xo-member-components/src/no-balance/factory');

var _factory3 = require('xo-member-components/src/rewards-checkbox/factory');

var _factory4 = require('xo-member-components/src/show-more-fi/factory');

var _factory5 = require('xo-wallet-components/src/add-card/addcard/factory');

var _factory6 = require('xo-address-components/src/address-normalization-edit/factory');

require('xo-title/dist/directive');

require('xo-styles/dist/lib/toggle');

require('xo-return-to-merchant/dist/util');

require('xo-wallet-components/src/3ds/directive');

require('xo-wallet-components/src/three-ds/directive');

require('xo-address-components/src/address-display/directive');

require('xo-form-components/src/select-shipping-method/directive');

require('xo-credit-components/src/xo-credit-offer-banners/directive');

require('xo-credit-components/src/xo-offer-top-banner/directive');

require('xo-credit-components/src/bml-display/xo-bml-popup/directive');

require('xo-credit-components/src/xo-credit-offer-banners/gb-banner/xo-credit-example-uk/directive');

require('xo-member-components/src/no-balance/directive');

require('xo-member-components/src/review-topup/directive');

require('xo-member-components/src/review-address/directive');

require('xo-member-components/src/review-paywith/directive');

require('xo-member-components/src/give-at-checkout/directive');

require('xo-page-components/src/notYou/directive');

require('xo-page-components/src/value-props/directive');

require('xo-page-components/src/marketingOffers/directive');

require('xo-page-components/src/messenger-plugin/directive');

require('xo-third-party-components/src/review-paywith-baidu/directive');

require('xo-third-party-components/src/review-paywith-venmo/directive');

require('xo-ui-components/src/banner/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/sticky-cta/directive');

require('xo-ui-components/src/expired-message/directive');

require('xo-ui-components/src/user-assist-banner/directive');

var _cardartInstrument = require('../services/cardart-instrument');

var _factory7 = require('../xo-select-fi/factory');

var _factory8 = require('./factory');

var _tokenizedFactory = require('./tokenizedFactory');

var _shippingChangeFeature = require('./lib/shippingChangeFeature.js');

var _xoShippingOptions = require('xo-shipping-options');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('xo-page-components/src/cpa-disclaimer/directive');

require('xo-page-components/src/decline-notification/directive');

require('./styles');

var _sharedUtil = require('../services/shared-util');

var _balance = require('../services/balance');

var _qs = require('qs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Create payload that contains relevant data about the checkout state at review page
function createReviewFptiPayload(_ref) {
    var checkoutSession = _ref.checkoutSession,
        _ref$isProcessTransit = _ref.isProcessTransition,
        isProcessTransition = _ref$isProcessTransit === undefined ? false : _ref$isProcessTransit;

    var payload = {
        shipping_address_id: checkoutSession.get('shipping.id')
    };

    if (checkoutSession.get('plan.conversion') && !isProcessTransition) {
        payload.currency_conversion_type = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.is_conversion_shown = checkoutSession.get('plan.conversion.changeable') ? 1 : 0;
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    } else if (checkoutSession.get('plan.conversion') && isProcessTransition) {
        payload.currency_conversion_selected = checkoutSession.get('plan.conversion.paypal') ? 'PAYPAL' : 'VENDOR';
        payload.currency_conversion_from_curr = checkoutSession.get('plan.conversion.from_code');
        payload.currency_conversion_to_curr = checkoutSession.get('plan.conversion.to_code');
    }
    if (_factory3.$RewardsCheckboxFactory.rewardsFound()) {
        var contentKeys = _factory3.$RewardsCheckboxFactory.getContentKeys(checkoutSession.plan);

        payload.fi_id = (0, _utils.getInstrumentID)(checkoutSession.plan);
        payload.rewards_type = contentKeys.issuerName;
        payload.rewards_amt = contentKeys.value.rewardAmount; // monetary amount
        if (!isProcessTransition) {
            payload.rewards_fi = _factory3.$RewardsCheckboxFactory.toString();
        }
    }
    if (checkoutSession.plan.sources && checkoutSession.plan.sources[0].isBillingPreferred) {
        payload.default_funding_option = checkoutSession.plan.sources[0].instrument_id;
    }
    payload.chosen_funding_option = checkoutSession.plan.primaryFs || checkoutSession.plan.sources ? (0, _utils.getInstrumentID)(checkoutSession.plan) : '';
    return payload;
}

var $xoReviewPageComponent = exports.$xoReviewPageComponent = _squid.$Component.extend('$xoReviewPageComponent', {
    tag: 'xo-review-page',
    template: _template2['default'],
    scope: {
        redirectiframe: '=?',
        redirectLightbox: '=?'
    },
    actions: {
        handleCancelApplicationModalClick: function handleCancelApplicationModalClick(event) {
            // if click anywhere else except X button on modal, do nothing
            if (event.target.className !== 'close ng-scope') {
                event.preventDefault();
            }
        },
        closeCancelApplicationModal: function closeCancelApplicationModal() {
            this.showCancelApplicationModal = false;
        },
        openCancelApplicationModal: function openCancelApplicationModal() {
            this.showCancelApplicationModal = true;
        },
        updatePreferredFi: function updatePreferredFi(logger) {
            if (this.makeFiPreferred && this.makeFiPreferred.selected) {
                var PreferredFi = new _fi.$PreferredFi({
                    preferred: [this.makeFiPreferred.fiId]
                });

                logger.info('checkout_fpti', { 'pref_fi_set': '1' });
                return PreferredFi.save({
                    transientError: true,
                    contingencies: {
                        DEFAULT: function DEFAULT() {}
                    }
                });
            }

            logger.info('checkout_fpti', { 'pref_fi_set': '0' });

            return _angular.$q.when();
        },
        onThreedsModalClose: function onThreedsModalClose() {
            this.showThreedsPopup = false;
        }
    },
    resolve: {},
    lifecycle: {
        reenter: function reenter() {
            var _this = this;

            var msgKeys = this.checkoutSession.get('message.msgKeys', []);

            if (msgKeys.indexOf('confirmUpop.confirmUpopOrChooseAltMethod') === -1) {
                this.showUnconfirmedUpopMsg = !!this.checkoutSession.unconfirmed_upop;
            }

            // Reset the selectedmethod indicator and state change listener
            if (this.setupMultipleFi) {
                this.setupMultipleFi();
            }

            var instrumentId = this.checkoutSession.get('fundingOptions.plans.0.primaryFs.id');

            // For CPA, if we reenter, e.g. from sidebar, into review page, we need to send the fundingOption plan
            // so the CPA disclaimer can be refreshed if plan changes. e.g. 2 page variant in PP Balance scenario.
            this.primaryplan = this.checkoutSession.get('fundingOptions.plans.0');

            // If FS has changed due to an update, reset the preferred FI checkbox
            if (this.makeFiPreferred && this.makeFiPreferred.fiId !== instrumentId) {
                _logger.$logger.info('checkout_fpti', { 'pref_fi_option_shown': '1' });
                this.makeFiPreferred.selected = false;
            }

            this.topupError = false; // set default value to false (hide error when enter)

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: this.checkoutSession })));

            // TODO: turn off `xo_hermes_preferred_expired_msg_review_page` since currently
            // it's not running. However, AuthRate team will be running this experiement again
            // this.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg(
            //     this.isNmj,
            //     this.checkoutSession
            // );

            // if (this.showExpiredMsg) {
            //     $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
            //         this.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
            //         this.preferredExpired = this.checkoutSession.getDisallowedPreferred();
            //     });
            // }
            (0, _xoShippingOptions.getShippingOptions)(this.token).then(function (shippingOptions) {
                _this.shippingOptions = shippingOptions;
            });

            // On re-enter to review page once after payment Method updated, forced to reset the cvv fields.
            if (msgKeys.indexOf('paymentMethod.paymentMethodUpdated') !== -1) {
                this.resetCVVContigency({ flow: 'page_refresh' });
            }

            _balance.$BalanceEligibilityFactory.init({ checkoutSession: this.checkoutSession }).then(function (currentState) {
                var eligibility = currentState.eligibility;

                if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                    _this.checkoutSession.message = {
                        type: 'info',
                        msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                    };
                    _logger.$logger.info('reivew_page_reenter_render_cip_incomplete_message');
                }
            });
        },
        populate: function populate() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('#outerWrapper').addClass('tokenization topup');
                var windowHeight = window.innerHeight || document.documentElement && document.documentElement.clientHeight;
                var footerHeaderHeight = document.querySelector('xo-header .paypalHeader').clientHeight + document.querySelector('xo-footer .footer').clientHeight;

                document.querySelector('.review .reviewTopup').style.minHeight = windowHeight - footerHeaderHeight - 5 + 'px'; // 5px for header/footer alignment
            }

            if (_squid.$locale.country === 'DE' && this.checkoutSession.creditOffer) {
                this.installment.showPPCAcquisitionRadioButton = true;
            }
        },
        exit: function exit() {
            if (this.checkoutCart.isWalletTokenization()) {
                (0, _jquery2['default'])('.tokenization').removeClass('topup');
            }
            _factory3.$RewardsCheckboxFactory.destroy();
        }
    },
    controller: ['$scope', '$element', function ($scope, $element) {
        // storing the buyer language on entry to review page
        // this is getting used when there is a language toggle for RTR (some other flows in future)
        $scope.buyerProfileLanguage = _squid.$locale.lang;
        $scope.choiceBalanceCheckboxState = _factory7.$BalanceFactory.get();
        $scope.tokenizedFactoryState = _tokenizedFactory.$TokenizedFactory.get();
        $scope.noBalanceFactoryState = _factory2.$NoBalanceFactory.get();
        $scope.vault = { checked: true };

        $scope.creditSharedInfo = _credit.$CreditSharedInfoModel.instance();

        $scope.isThirdPartyWalletExperience = function () {
            var experience = _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);

            return experience === 'BAIDU_EXPERIENCE' || experience === 'VENMO_EXPERIENCE';
        };

        $scope.determineThirdPartyWalletExperience = function () {
            return _thirdPartyInfo.thirdPartyExperience.getExperience(_angular.$rootScope.token);
        };

        $scope.creditParentContext = {
            populated: false,
            newMember: {},
            showCreditOffer: true // Flag for experimenting with display of the Credit Offer based on CEP
        };

        $scope.showCreditDisallowedMessage = function () {
            var isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;
            return isCreditDisallowedForMerchant && !_angular.$rootScope.showFiSelectPage;
        };

        $scope.creditDisallowedMessage = {
            type: 'info',
            msgs: [_squid.$locale.content.get('memberReview.useDebitCard')]
        };

        $scope.memberSegment = _marketingoffer2.$MemberSegmentModel.instance();

        $scope.isPPCReuseAndNotSelected = function () {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && !fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };
        $scope.isMessengerBAIntegration = _integration.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');

        $scope.isDEInstallmentsApproved = function () {
            var deInstallmentsPlanSelected = false;
            if (_squid.$locale.country === 'DE') {
                var plans = $scope.checkoutSession.getPlanList();
                if (plans) {
                    deInstallmentsPlanSelected = plans.filter(function (p) {
                        return p.primaryFs.type === 'CREDIT' && p.primaryFs.name === 'BILL_ME_LATER' && p.selected;
                    }).length > 0;
                }
            }
            // User got approved in CAPE if the DE installments plan is selected - return true
            if (deInstallmentsPlanSelected) {
                return true;
            }
            return false;
        };

        $scope.showCreditPlacement = function () {
            // for xo-offer handling
            $scope.creditParentContext.newMember.creditOffer = $scope.memberSegment && $scope.memberSegment.creditOffer;

            var show = !$scope.isThirdPartyWalletExperience() && $scope.creditParentContext.populated && $scope.creditParentContext.showCreditOffer && !_angular.$rootScope.showFiSelectPage && ($scope.checkoutSession.creditOffer || $scope.isPPCReuseAndNotSelected()) && !$scope.isMessengerBAIntegration && _squid.$locale.country !== 'DE' && !isUSCrossCurrency();

            return show;
        };

        $scope.showRepresentativeExample = function () {
            function isPPCNotSelected() {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                var selectedFi = plans && plans.find(function (fi) {
                    return fi.selected;
                });

                return !(selectedFi && selectedFi.name === 'BILL_ME_LATER');
            }

            return _squid.$locale.country === 'GB' && !(_angular.$rootScope.showFiSelectPage && isPPCNotSelected()) && $scope.creditSharedInfo.shouldShowCreditExample();
        };

        $scope.isProcessorDeclineExperiment = false;

        var applyNewMemberVariant = function applyNewMemberVariant() {
            return _newMember.$NewMemberEligibility.instance().getVariant(_angular.$rootScope.token).then(function (variant) {
                // feature flag for one page nmj experience
                var isNmjDesign1 = $scope.isNmjDesign1 = variant === 'one_page';
                // feature flag for one page nmj design 2 experience
                var isNmjDesign2 = $scope.isNmjDesign2 = variant === 'design_2';
                // feature flag for one page nmj design 3 experience
                var isNmjDesign3 = $scope.isNmjDesign3 = variant === 'design_3';
                // umbrella flag for nmj experience
                var isNmj = $scope.isNmj = isNmjDesign1 || isNmjDesign2 || isNmjDesign3;

                $scope.showViewYourPaymentRights = (isNmjDesign2 || isNmjDesign3) && _squid.$locale.country === 'US';
                $scope.showGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;
                $scope.nmjExperience = {
                    one_page: $scope.isNmjDesign1,
                    design_2: $scope.isNmjDesign2,
                    design_3: $scope.isNmjDesign3
                };

                // set assist-banner content based on type of nmj flow - if any
                var isPayNow = $scope.useraction === 'commit';
                var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                if (isNmjDesign1) {
                    $scope.assistBannerHeader = _squid.$locale.content.get('memberReview.assistHeader_1page');
                    $scope.assistBannerBody = _squid.$locale.content.get(isPayNow ? 'memberReview.assistBody_paynow_1page' : 'memberReview.assistBody_continue_1page');
                } else if ($scope.showGreyHeader) {
                    if (isPayNow) {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgPayNow', { userName: userName });
                    } else {
                        $scope.headerMsg = (0, _squid.$renderContent)('memberReview.nmjDesign2HeaderMsgContinue', { userName: userName });
                    }
                }
                $scope.creditParentContext.newMember.variant = variant;
                $scope.creditParentContext.newMember.useCEPDecision = isNmj;
                $scope.creditParentContext.populated = true;
                $scope.showPaypalPolicy = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && !$scope.showViewYourPaymentRights;
                $scope.showPaymentRights = !$scope.isThirdPartyWalletExperience() && $scope.showPaypalPolicies && $scope.showViewYourPaymentRights;
                _logger.$logger.info('member_ryi_variant_' + (variant || 'unknown'), {
                    isNmj: isNmj,
                    variant: variant
                });
                triggerPersonalizedBanner();
            });
        };

        var triggerPersonalizedBanner = function triggerPersonalizedBanner() {
            $scope.personalizedBanner.trigger();
        };

        if ($scope.isThirdPartyWalletExperience()) {
            // log buyer type for third Party usecases
            _logger.$logger.info('buyer_info', {
                fpti_buyer_type: $scope.determineThirdPartyWalletExperience() === 'VENMO_EXPERIENCE' ? 'Guestuser_venmo' : 'nonloginmember_benteley'
            });
        } else {
            // log existing buyer
            _logger.$logger.info('buyer_info', { fpti_buyer_type: 'Existinguser' });
        }

        // ----------------- OUTRO PXP VARS - START -------------------- //
        // NOTES: `xo_hermes_exit_msg` pxp has ramped to 100% and will always
        // return `xo_hermes_exit_msg_option5` treatment.
        // See: https://engineering.paypalcorp.com/pxptool/configuration?exptId=2609&version=9
        var pxpMerchNameLimit = 20; // max length of the merchant name
        var pxpMerchName = void 0; // the brand or merchant name - resolved after retrieving appdata

        // ----------------- OUTRO PXP VARS - END -------------------- //
        $scope.token = _angular.$rootScope.token;
        $scope.backUri = 'checkout.review';
        $scope.installmentNotSelected = false;
        $scope.installment = {
            showBanner: false,
            showCYCO: false,
            showCreditExample: false,
            financing_details: null
        };

        // PAD Toggle feature
        $scope.padToggleFeature = {
            applicable: false,
            checkboxEnabled: false,
            showCheckbox: false,
            defaultPlan: false,
            pxpControlEnabled: false,
            fptiLogged: false,
            multiFiCheckboxStates: {}
        };

        // 'continue' or 'pay now' button text
        $scope.payButtonText = function () {
            return '';
        };
        $scope.isGCcountry = (_squid.$config.giftCardSupportedCountries || '').indexOf(_squid.$locale.country) > -1;
        $scope.showPaypalPolicies = (0, _squid.$featureCountries)('showPaypalPolicies').indexOf(_squid.$locale.country) > -1;
        $scope.makeAddrPreferred = {
            shown: false,
            selected: false
        };
        $scope.showPolicyAgreement = (0, _squid.$feature)('showPolicyAgreement');

        var _ref2 = window.xprops || {},
            _ref2$experience = _ref2.experience,
            experience = _ref2$experience === undefined ? { facebook: false, autoBA: false } : _ref2$experience;

        $scope.isFacebookBAIntegration = experience.facebook;

        $scope.personalizedBanner = {
            show: false,

            trigger: function trigger() {
                var isOneTouchBanner = $scope.auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
                var newMemberDesign1 = $scope.isNmjDesign1;

                $scope.personalizedBanner.show = newMemberDesign1 || isOneTouchBanner || $scope.auth.isFBSkipLogin();

                // for Facebook skip login set isFBSkipLogin as true to modify the skip login content
                $scope.personalizedBanner.isFBSkipLogin = $scope.auth.isFBSkipLogin();

                // FPTI payload to track FB Login
                if ($scope.auth.isFBSkipLogin()) {
                    _logger.$logger.info('checkout_fpti', {
                        'design': 'facebook_onetouch'
                    });
                }
            }
        };

        $scope.optin_toggle = {
            isEnabled: false,
            value: false,
            showExpandedTerms: true,
            setValue: function setValue(val) {
                this.value = val;
                // this.showExpandedTerms = false; // hide terms upon user interaction
                _logger.$logger.debug('ryi_optin_toggle_setValue', {
                    value: this.value,
                    showExpandedTerms: this.showExpandedTerms
                });
            }
        };
        _logger.$logger.debug('kmliUpsell review: init');
        _kmliUpsell.$KmliUpsell.init(_angular.$rootScope.token, false, true);
        var creditBannerRegister = _angular.$rootScope.$on('allLoaded', function () {
            _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T1' });
            creditBannerRegister();
        });
        _angular.$rootScope.$on('$destroy', creditBannerRegister);

        function optInUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optin'
            });
            $scope.optin_toggle.setValue(true);
            var optinSource = 'checkoutToggle';
            var silentSpinner = true;

            return _ul.$ul.optInToOneTouch(_angular.$rootScope.token, _squid.$locale.country, _squid.$locale.lang, silentSpinner, {
                'stateName': 'OT_Toggle',
                'transInfix': 'process_optin'
            }, optinSource).then(function (res) {
                _logger.$logger.debug('ryi_optin_toggle_process_optin');
            })['catch'](function (err) {
                // eslint-disable-line handle-callback-err
                _logger.$logger.debug('ryi_optin_toggle_process_optin_Error', {
                    'int_error_description': err && err.message
                });
            });
        }

        function optOutUser() {
            // eslint-disable-line no-unused-vars
            _logger.$logger.info('ryi_optin', {
                'from': 'OT_Toggle',
                'to': 'prepare_optout'
            });
            return $scope.auth.action('optout', { silent: true }).then(function (res) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout'
                });
                $scope.$applyAsync(function () {
                    var bannerElement = $element.find('.oneTouchBanner');

                    bannerElement.addClass('leave_animation');
                    _logger.$logger.debug('ryi_optin bannerElement animate');
                    (0, _angular.$timeout)(function () {
                        $scope.optin_toggle.setValue(false);
                        $scope.optin_toggle.isEnabled = false;
                    }, 1400);
                });
            })['catch'](function (err) {
                _logger.$logger.info('ryi_optin', {
                    'from': 'OT_Toggle',
                    'to': 'process_optout',
                    'error_source': 'identityauthorizationserv',
                    'int_error_code': 'optout_failure',
                    'int_error_description': err && err.message
                });
            });
        }

        $scope.onTouchToggle = function (value) {
            _logger.$logger.debug('optin_toggle_change_attempt', {
                'ryi_optin': $scope.optin_toggle,
                'remembered': $scope.auth.remembered,
                'value': value
            });
            if ($scope.optin_toggle.isEnabled) {
                if (value) {
                    optInUser();
                } else {
                    optOutUser();
                }
            }
        };

        $scope.tagFamilyComputer = function () {
            // creates a log to tag device as family computer.
            // if we can distinguish between single user, family computer and shared computer
            // we may be able to offer a way to switch accounts
            var buyer_id = $scope.auth.buyer_id;
            var logPayload = {
                localStorageEnabled: false,
                isMobile: _index2.$DeviceInfo.isMobile()
            };

            if (_squid.$util.localStorageEnabled()) {
                var family_device_key = 'family_device_test';
                var public_device_key = 'public_device_test';

                logPayload.localStorageEnabled = true;

                var objStr = localStorage.getItem(family_device_key);
                var publicDeviceTest = localStorage.getItem(public_device_key);

                if (publicDeviceTest === 'true') {
                    // dont overuse localStorage there is a size limit
                    localStorage.removeItem(family_device_key);
                    logPayload.isPublicDevice = true;
                } else {
                    var buyerList = objStr ? JSON.parse(objStr) : [];

                    if (buyerList.indexOf(buyer_id) === -1) {
                        buyerList.push(buyer_id);
                    }
                    // assuming 5 or less users on a device as family computer
                    logPayload.isFamilyDevice = Boolean(buyerList.length > 1 && buyerList.length < 6);
                    logPayload.isPublicDevice = Boolean(buyerList.length > 20);
                    logPayload.userCount = buyerList.length;
                    objStr = JSON.stringify(buyerList);
                    localStorage.setItem(family_device_key, objStr);
                    localStorage.setItem(public_device_key, logPayload.isPublicDevice.toString());
                }
            }
            var eligibility_reason = 'localStorage:' + logPayload.localStorageEnabled + '_isPublicDevice:' + logPayload.isPublicDevice + '_isFamilyDevice:' + logPayload.isFamilyDevice + '_userCount:' + logPayload.userCount;

            _logger.$logger.debug('family_device_test', logPayload);
            _logger.$logger.info('checkout_fpti', {
                'from': 'family_device_test',
                'to': 'process_elg_chk',
                'eligibility_reason': eligibility_reason
            });
        };

        function stickyCTA() {
            return _eligibility.$stickyCTA.instance().getEligibility().then(function (eligibility) {
                $scope.stickyEligibility = eligibility;
            });
        }

        // Format the informal name if populated
        function setInformalName() {
            if ($scope.auth) {
                $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                }) || $scope.auth.email;
            }
        }

        function donationAuthorize() {
            var _$GiveAtCheckoutFacto = _factory.$GiveAtCheckoutFactory.get(),
                donateCheckboxSelected = _$GiveAtCheckoutFacto.donateCheckboxSelected,
                charity = _$GiveAtCheckoutFacto.charity,
                tracking = _$GiveAtCheckoutFacto.tracking;

            if (donateCheckboxSelected) {
                _logger.$logger.info('checkout_fpti', {
                    from: 'GIVE_AT_CHECKOUT',
                    to: 'process_give_at_checkout',
                    gac_model: charity.model_id,
                    gac_npid: charity.nonprofit_id
                });

                if (tracking && tracking.click_url) {
                    _marketingoffer.$fireMORSBeacon.fireBeacon(tracking.click_url);
                }

                return _donation.$GiveAtCheckoutModel.instance().action('donationAuthorize', {
                    data: {
                        'ec_token': _angular.$rootScope.token,
                        'nonprofit_id': charity.nonprofit_id,
                        'charity_name': charity.name,
                        'money': {
                            'value': charity.amount,
                            'currency_code': charity.currency
                        }
                    },
                    success: function success() {
                        return _logger.$logger.info('donation_authorize_success', {});
                    },
                    error: function error() {
                        return _logger.$logger.error('donation_authorize_failure');
                    }
                });
            }
        }

        function updateAddressAsPreferred() {
            if ($scope.makeAddrPreferred.shown) {
                _logger.$logger.info('makeAddrPreferred.shown', {});
            }

            if ($scope.makeAddrPreferred.selected) {
                _logger.$logger.info('makeAddrPreferred.selected', {});
                // Ignore all errors from setPreferred api, by passing transientError as true
                return $scope.checkoutSession.shipping.action('setPreferred', {
                    transientError: true
                });
            }
            return _angular.$q.when();
        }

        function setStickyInstrument() {
            if (!_squid.$config.features.DEFAULT.enableStickyFunding) {
                return _angular.$q.when();
            }

            // If the currently selected plan is not saved in the checkoutSession, make the call to save it.
            // For BA no purchase cases, the only way we track it is in the checkout session, so it should already be saved (selected id will equal sticky id).
            // For all other purchase cases, we need to look at the first in fundingOptions and match it to futurePaymentInstruments
            var savedSticky = $scope.checkoutSession.selectedFuturePaymentInstrument;
            var selectedSticky = $scope.checkoutSession.getSelectedStickyInstrument();

            // selectedSticky will not be populated if this isn't a billing case.
            if (!selectedSticky) {
                return _angular.$q.when();
            }

            // If we haven't saved the selected sticky instrument yet,
            // make the API call to save it
            if (!savedSticky || savedSticky.instrument_id !== selectedSticky.instrument_id) {
                return $scope.checkoutSession.action('setStickyFI', {
                    data: {
                        instrument_id: selectedSticky.instrument_id
                    }
                });
            }
            return _angular.$q.when();
        }

        function linkAuthConsent() {
            /* Check if its BA flow and we have merchant consent code */
            if ($scope.checkoutCart.isBilling() && $scope.checkoutCart.billing) {
                // Getting merchant account's billing consent code i.e. legal_text_code
                var billingConsentCode = $scope.checkoutCart.billing.consent_code;
                var FB_CONSENT_CODE = 'facebookp2p';
                var authConsentModel = _user.$AuthConsentModel.instance();

                if (billingConsentCode === FB_CONSENT_CODE) {
                    return authConsentModel.action('link', {
                        data: {
                            'ba_token': _squid.$meta.baToken
                        },
                        success: function success() {
                            return _logger.$logger.info('link_authconsent_success', {});
                        }
                    });
                }
            }
        }

        function setWalletTopupPreferences() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                $scope.walletPreferences = _fi.$WalletPreferences.instance(_angular.$rootScope.token);
                return $scope.walletPreferences.save();
            }
        }

        function isValidPinSetup() {
            if ($scope.walletPinModel && $scope.walletPinModel.isSetupEligible()) {
                if (!$scope.walletPinModel.userPin) {
                    return false;
                }
            }
            return true;
        }

        function prepareTokenizedWallet() {
            if ($scope.checkoutCart.isWalletTokenization()) {
                return (0, _squid.$populate)($scope, {
                    walletPreferences: _fi.$WalletPreferences.instance(_angular.$rootScope.token),
                    walletPinModel: _app.$TokenizedWalletPinModel.instance(_angular.$rootScope.token),
                    tokenizedFundingCapabilitiesModel: _app.$TokenizedFundingCapabilitiesModel.instance(_angular.$rootScope.token).retrieve({
                        params: {
                            tokenizedWalletToken: $scope.checkoutCart.tokenizedWalletToken,
                            country: $scope.auth.country
                        }
                    })
                }).then(function (result) {
                    var fundingInstrument = $scope.walletPreferences.getPreferred();
                    var instrument_id = fundingInstrument.instrument_id;
                    var defaultTopupFI = _squid.$util.find($scope.checkoutSession.topupFundingSources, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var defaultDirectFI = _squid.$util.find($scope.checkoutSession.futurePaymentInstruments, function (fs) {
                        return fs.instrument_id === instrument_id;
                    }) || {};
                    var pinStatus = 'default_pin_unavailable';

                    if ($scope.walletPinModel.isPinIdPresent()) {
                        pinStatus = 'already_exist';
                    } else if ($scope.walletPinModel.getPinOrigin() !== 'UNSET') {
                        pinStatus = 'pin_error';
                    } else if ($scope.walletPinModel.getSuggestedPin()) {
                        pinStatus = 'default_pin_available';
                    }

                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'TopUp_REVIEW',
                        'to': 'prepare_review',
                        'context_id': $scope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken,
                        'default_topup_fi': defaultTopupFI.type,
                        'default_direct_fi': defaultDirectFI.type,
                        'pin': pinStatus,
                        'flag': $scope.checkoutSession.get('sepa_mandate.bankId') ? 'sepa' : undefined
                    });
                });
            }
            return _angular.$q.when();
        }

        $scope.hasShippingOptions = function () {
            return Boolean($scope.shippingOptions && $scope.shippingOptions.length);
        };

        function checkJSV4PaymentDetails() {
            // Pass through if there are no shipping methods to choose from.
            if (!$scope.hasShippingOptions()) {
                return _angular.$q.when();
            }

            // Otherwise, if there are shipping methods but no selected method... Fail!
            if (!$scope.selectedShippingOption) {
                $scope.checkoutSession.message = {
                    type: 'error',
                    msgKeys: ['shipping.bopisErrorMessage']
                };

                throw new Error('IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION');
            }
        }

        /**
         * To resetCVVContingency once the page refresh/back happen.
         *
         * case1. browser_back:
         *          Reset the hash value in the url with '#', no page load occurs.
         *          once browser back click the cache clean and cvv text box will show.
         * case2. page_refresh:
         *          reset the lastAddedCard to false
         *          every page refresh the cvv text box will display.
         */
        $scope.resetCVVContigency = function (_ref3) {
            var flow = _ref3.flow;


            var isResolve3ds = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;
            var isReviewPage = _uiRouter.$state.current.name === 'checkout.review';

            if (isResolve3ds && isReviewPage && checkResetCvvAllowed()) {
                _logger.$logger.info('checkout_fpti', { from: 'resetCVVContigency_' + flow, to: 'process_resetCVVContigency_' + flow });
                var ccId = isResolve3ds.ccId,
                    type = isResolve3ds.type,
                    number = isResolve3ds.number;


                switch (flow) {
                    case 'page_refresh':
                        $scope.checkoutSession.set('cvvData', Object.assign({}, { type: type, number: number, ccId: ccId, id: ccId, lastAddedCard: false }));
                        break;
                    case 'browser_back':
                        _angular.$window.location.hash = '#';
                        break;
                    default:
                        break;
                }
            }
        };

        /**
         * Parse the queryString
         * - set the required scopes for init3DS paymentExperience
         * - set return query while return to merchaant
         */
        var parseQueryStringForExperience = function parseQueryStringForExperience() {
            var isDoEcEnabled = !window.xchild && $scope.checkoutAppData.doec_on_approve() ? 1 : 0;

            var searchParams = (0, _qs.parse)(_angular.$window.location.search.split('?')[1]);
            searchParams = Object.assign({}, searchParams, { isDoEcEnabled: isDoEcEnabled, hermes: '1', token: $scope.token });
            delete searchParams.cmd;
            $scope.process3dsReturnQueryParams = (0, _qs.stringify)(searchParams);
            var searchParamThreeDSexp = searchParams['threeDSexp'];

            if (searchParamThreeDSexp === 'redirect' || searchParamThreeDSexp === 'iframe') {
                $scope.isRedirectTreatment = searchParamThreeDSexp === 'redirect';
                _logger.$logger.info('checkout_fpti', { from: '3ds_exp_queryString_' + $scope.isRedirectTreatment, to: 'process_3ds_exp__queryString_' + $scope.isRedirectTreatment });
            }
        };

        /**
         * Get paymentExperience from URL for experiemenation
         *
         * @return {Array}
         */
        function getPaymentExperience() {
            var paymentExperience = void 0;

            $scope.threeDSexp = $scope.isRedirectTreatment ? 'REDIRECT' : 'IFRAME';
            $scope.channelType = $scope.threeDSexp === 'REDIRECT' ? 'MOBILE_APP' : 'WEB';
            paymentExperience = [$scope.threeDSexp];

            //  if the merchant integrated with incontext experience then we need to send 'IFRAME' as experience
            if (_index.$miniBrowser.isMiniBrowser()) {
                $scope.isMiniBrowser = _index.$miniBrowser.isMiniBrowser();
                _logger.$logger.info('checkout_fpti', { from: 'override_as_iframe', to: 'process_override_as_iframe' });
                $scope.channelType = 'WEB';
                $scope.isRedirectTreatment = false;
                paymentExperience = ['IFRAME'];
            }
            return paymentExperience;
        }

        /**
         * To check the elmo treatment for the 3ds experience
         *
         * return {Boolean}
         */
        var checkExperienceElmoTreatment = function checkExperienceElmoTreatment() {
            var _$scope$checkoutSessi = $scope.checkoutSession.payer;
            _$scope$checkoutSessi = _$scope$checkoutSessi === undefined ? {} : _$scope$checkoutSessi;
            var payerId = _$scope$checkoutSessi.id;
            var _$config$pxpExperimen = _squid.$config.pxpExperiments.hermesElmo3dsExperience,
                id = _$config$pxpExperimen.id,
                testTreatmentName = _$config$pxpExperimen.testTreatmentName;

            var merchantCountryCode = $scope.checkoutAppData.get('merchant.merchant_country');

            if (!(0, _squid.$feature)('callElmoForPaymentExperience')) {
                parseQueryStringForExperience();
                return;
            }

            (0, _squid.$elmo)(id, { 'filters.Country': _squid.$locale.country, 'uid': payerId, 'filters.MerchantCountry': merchantCountryCode }, testTreatmentName, false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                if (treatmentName) {
                    _logger.$logger.info('treatmentName_exist', treatmentName);
                    $scope.isRedirectTreatment = true;
                }

                _logger.$logger.info('checkout_fpti', {
                    from: 'isRedirectTreatment',
                    to: 'process_3ds_isRedirectTreatment',
                    data: { isRedirectTreatment: $scope.isRedirectTreatment }
                });
            })['finally'](function () {
                parseQueryStringForExperience();
            });
        };

        /**
         * Get Security code from cvvData
         */
        function getSecurityCode() {
            if (checkResetCvvAllowed()) {
                return _angular.$rootScope.cvvData && _angular.$rootScope.cvvData.security_code;
            }
        }

        /**
         * Set CVV data from CheckoutSessionModel
         */
        function setCvvData() {
            if (checkResetCvvAllowed()) {
                _angular.$rootScope.cvvData = $scope.checkoutSession.get('cvvData') ? $scope.checkoutSession.get('cvvData') : _angular.$rootScope.cvvData;
            }
        }

        /**
         * check whether to allow reset cvv based on country
         * - reset CVV value
         * - show cvv text box
         */
        function checkResetCvvAllowed() {
            var resetCVVAllowedCountries = ['IN'];
            _logger.$logger.info('checkout_fpti', {
                from: 'checkResetCvvAllowed',
                to: 'process_checkResetCvvAllowed',
                resetCVVAllowedCountries: resetCVVAllowedCountries
            });
            return resetCVVAllowedCountries.includes(_squid.$locale.country);
        }

        function show3DSLightbox() {
            $scope.resolve_3ds_data = set3DSv1ScopeVariable();

            $scope.launch3DSResolver = true;
        }

        // 3DS V2 device data collection - group it together with V1 for easy reference
        function show3dsDDCLightBox() {
            $scope.threedsData = set3DSv2ScopeVariable();
            $scope.showThreedsPopup = true;
        }

        function setProcessorDeclineMessage(checkoutSession) {
            var declinedInstruments = checkoutSession.declinedInstruments;

            // For CPA scenario, when pre auth decline, we reload the review page and for that we would have
            // decline instrument but we dont want to show existing Processor Decline Message. Instead CPA message
            // would be shown on review page (we have separate component 'decline-notification' for displaying CPA Message.
            // So filtering the below logic, if user is not CPA Eligible.
            if (declinedInstruments && declinedInstruments.length > 0 && !$scope.isCPAEligible) {
                _factory5.$AddCardFactory.getIssuerDeclineElmoResult().then(function (result) {
                    // reset the checkoutSession.message;
                    checkoutSession.message = null;

                    var planInstruments = checkoutSession.fundingOptions.plans || [];
                    var treatmentPAPS = null;

                    planInstruments.forEach(function (plan) {
                        if (plan.primaryFs.lastDigits === declinedInstruments[0].last4 && plan.primaryFs.name.toLowerCase() === declinedInstruments[0].card_type.toLowerCase()) {
                            treatmentPAPS = 'Trmt_xo_hermesnodeweb_issuer_decline_1';
                            $scope.isProcessorDeclineExperiment = true;
                        }
                    });

                    var processorDeclinedMsg = _fiMessages.$fiMessages.processorDeclinedMsg($scope.checkoutSession, true, treatmentPAPS, $scope.auth, $scope.fiMeta.wallet, $scope.formattedNameInformal);

                    if (processorDeclinedMsg) {
                        $scope.checkoutSession.message = {
                            type: processorDeclinedMsg.type,
                            msgs: [processorDeclinedMsg.msg],
                            keepMsg: processorDeclinedMsg.keepMsg
                        };
                    }
                });
            }
        }

        function getPadToggleStatus() {
            var toggleStatus = 'NA'; // NOT APPLICABLE status

            if (_factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled)) {
                if ($scope.padToggleFeature.checkboxEnabled) {
                    toggleStatus = 'ON';
                } else {
                    toggleStatus = 'OFF';
                }
            }
            return toggleStatus;
        }

        // method to extract information for 3DSv1.0
        function set3DSv1ScopeVariable() {
            // for v2 resolve_3ds is null, pass it from V2 mapping to get amount and currency
            var cc_id = $scope.checkoutSession.get('resolve_3ds.ccId');
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;

            return {
                cc_id: cc_id,
                flow_id: 'HERMES',
                merchant_id: $scope.payee.get('merchant.id'),
                merchant_country_code: $scope.checkoutAppData.get('merchant.merchant_country'),
                transaction_amount_currency: plan && plan.currency_code || null,
                transaction_amount_value: plan && plan.amount || null,
                merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                card_verification_code: getSecurityCode(),
                paymentExperience: getPaymentExperience(),
                channelType: $scope.channelType,
                isMiniBrowser: $scope.isMiniBrowser,
                isRedirectTreatment: $scope.isRedirectTreatment,
                process3dsReturnQueryParams: $scope.process3dsReturnQueryParams
            };
        }

        function getProductDetails() {
            // default to express checkout
            var productDetails = {
                productCode: 'EXPRESS_CHECKOUT',
                productFlow: 'HERMES'

            };

            var isWPSFlow = $scope.checkoutAppData.is_wps_flow();
            var isBillingWithoutPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBillingWithPurchase = $scope.checkoutCart.isBillingPurchase();
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();

            if (isWPSFlow) {
                productDetails.productCode = 'WEBSITE_PAYMENT_STANDARD';
            } else if (isBillingWithoutPurchase || isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENTS';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_CREATE';
            } else if (isWPSSubscriptionFlow) {
                productDetails.productCode = 'BILLING_SUBSCRIPTIONS';
                productDetails.productFlow = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE';
            } else if (isWPSAutobilling) {
                productDetails.productCode = 'BILLING_AUTOBILLING';
                productDetails.productFlow = 'BUYER_APPROVAL_AUTOBILLING_CREATE';
            } else if (isBillingWithPurchase) {
                productDetails.productCode = 'BILLING_AGREEMENT';
                productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE';
            }

            return productDetails;
        }

        function isBillingFlow() {
            return $scope.checkoutCart.isBilling() || $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.isWpsAutobillingFlow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1();
        }

        // method to extract information for 3DSv2.0
        function set3DSv2ScopeVariable() {
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref4 = threeDSResolutionData.resolutions || [],
                resolutions = _ref4[0];

            var _ref5 = resolutions || {},
                _ref5$funding_instrum = _ref5.funding_instrument_details;

            _ref5$funding_instrum = _ref5$funding_instrum === undefined ? {} : _ref5$funding_instrum;
            var _ref5$funding_instrum2 = _ref5$funding_instrum.payment_card,
                payment_card = _ref5$funding_instrum2 === undefined ? {} : _ref5$funding_instrum2,
                _ref5$funding_instrum3 = _ref5$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref5$funding_instrum3 === undefined ? {} : _ref5$funding_instrum3;

            // logo image url

            var networkLogo = $scope.fiMeta.wallet.getCardArt(payment_card);
            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var plans = $scope.checkoutSession.get('plan.sources', null);
            var plan = plans && plans.filter(function (e) {
                return e.instrument_id === cc_id;
            })[0].amount || null;
            var amount = {
                currencyCode: plan && plan.currency_code,
                currencyValue: plan && plan.amount
            };

            var jwtInfo = {
                jwtIssuer: three_ds_contingency_context.auth_specification.issuer,
                jwtOrgUnitId: three_ds_contingency_context.auth_specification.org_unit_id,
                jwtDuration: three_ds_contingency_context.auth_specification.validity_duration
            };

            var threeDSContingencySource = three_ds_contingency_context.source,
                threeDSContingencyReason = three_ds_contingency_context.reason;
            var id = payment_card.id,
                bank_identification_number = payment_card.bank_identification_number,
                billing_address = payment_card.billing_address,
                number_encrypted = payment_card.number_encrypted,
                card_product_class = payment_card.card_product_class,
                expire_month = payment_card.expire_month,
                expire_year = payment_card.expire_year,
                currency_code = payment_card.currency_code,
                type = payment_card.type;


            if (isBillingFlow()) {
                amount.currencyValue = '0.00';
                amount.currencyCode = currency_code;
            }
            return {
                cardBin: bank_identification_number, // Needed for JWT
                ddcUrl: three_ds_contingency_context.device_data_collection_url,
                jwtInfo: jwtInfo, // Needed for JWT
                referenceId: three_ds_contingency_context.reference_id,
                integrationType: 'TRANSACTION',
                networkLogo: networkLogo,
                cardBrand: type,
                initThreedsData: {
                    referenceId: three_ds_contingency_context.reference_id,
                    creditCardId: id,
                    billing_address: billing_address,
                    number_encrypted: number_encrypted,
                    card_product_class: card_product_class,
                    expire_month: expire_month,
                    expire_year: expire_year,
                    amount: amount,
                    threeDSContingencySource: threeDSContingencySource,
                    threeDSContingencyReason: threeDSContingencyReason,
                    merchant_category_code: $scope.payee.get('merchant.merchant_category_code'),
                    productDetails: getProductDetails()
                }
            };
        }

        /**
         * `Exit message` feature is currently only applied to:
         * 1) Only in US
         * 2) user action **not** "commit"
         * 3) not a billing agreement
         * 4) `DONE_PAGE` integration is false
         * @returns {boolean}
         */
        var applyExitMessage = function applyExitMessage() {
            return _squid.$locale.country === 'US' && $scope.useraction !== 'commit' && !$scope.checkoutCart.isBilling() && !_integration.$integration.getConfig('DONE_PAGE');
        };

        var getPlanId = function getPlanId(obj) {
            return obj.planId || obj.id;
        };

        var getPlan = function getPlan(planId) {
            var planList = $scope.checkoutSession.get('fundingOptions.plans') || [];
            var selectedPlan = void 0;

            angular.forEach(planList, function (plan) {
                if (getPlanId(plan) === planId) {
                    selectedPlan = plan;
                }
            });
            return selectedPlan;
        };
        var getDefaultPlanId = function getDefaultPlanId() {
            return $scope.checkoutSession.plan.id || [];
        };

        var getSpinnerContentTest = function getSpinnerContentTest() {
            return (0, _squid.$elmo)('xo_hermesnodeweb_cpa_spinner', { 'ctx.country': _squid.$locale.country }, 'xo_hermesnodeweb_cpa_spinner_trmt(_[0-9]+)?').then(function (result) {
                return result && result.treatment_name;
            });
        };

        /* Function for Pre auth API - "/v2/payments/authorizations"
           Pre auth call would be invoked if the user is CPA Eligible and selected (or default, if user did not select)
           plan has pre auth data. otherwise we will skip and move forward with approve call.
         */
        var preAuthorize = function preAuthorize() {
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var preAuthorizationData = selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.pre_authorization_instruction;
            var _$scope$checkoutSessi2 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi2 = _$scope$checkoutSessi2 === undefined ? {} : _$scope$checkoutSessi2;
            var payerId = _$scope$checkoutSessi2.id;

            var preAuthorizationRequired = false;
            var authAmount = void 0;

            if (preAuthorizationData) {
                var authType = preAuthorizationData.type;

                authAmount = preAuthorizationData.amount;
                preAuthorizationRequired = authType === 'FULL' || authType === 'PARTIAL';
            }

            if (preAuthorizationRequired) {
                var fptiData = {
                    fi_id: selectedPlan.primaryFs.id,
                    plan_id: selectedPlanId,
                    auth_type: preAuthorizationData.type,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue'
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'CREATE_FI_AUTH',
                    to: 'prepare_fi_auth',
                    client_epoch_ts: Date.now()
                }, fptiData));

                getSpinnerContentTest().then(function (treatment) {
                    if (treatment) {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - treatment');

                        var loadingMessage = void 0;
                        var loadingSubMessage = void 0;
                        switch (treatment) {
                            case 'xo_hermesnodeweb_cpa_spinner_trmt':
                                loadingMessage = (0, _squid.$renderContent)('spinner.authFlowContinue', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine2', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_2':
                                loadingMessage = (0, _squid.$renderContent)('spinner.preAuthCard').toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            case 'xo_hermesnodeweb_cpa_spinner_trmt_3':
                                loadingMessage = (0, _squid.$renderContent)('spinner.completePayment', { merchantName: $scope.checkoutAppData.merchant.brand_name }).toString();
                                loadingSubMessage = (0, _squid.$renderContent)('disclaimer.fullAuthMoreInfoLine3').toString();
                                break;
                            default:
                                loadingMessage = '';
                                loadingSubMessage = '';
                        }

                        _squid.$event.emit('loading');
                        _squid.$event.emit('loadingMessage', {
                            heading: loadingMessage,
                            subHeading: loadingSubMessage
                        });
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');
                            var spinnerSubMessageEl = (0, _jquery2['default'])('#spinner-submessage');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '150%',
                                    marginLeft: '-55px'
                                });
                            }
                            if (spinnerSubMessageEl) {
                                spinnerSubMessageEl = spinnerSubMessageEl.css({
                                    width: '168%',
                                    marginLeft: '-75px',
                                    marginTop: '20px'
                                });
                            }
                        }, 1);
                    } else {
                        _logger.$logger.info('xo_hermesnodeweb_cpa_spinner - control');
                    }
                });

                return $scope.checkoutSession.action('preAuthorize', {
                    data: {
                        authAmount: authAmount,
                        planId: selectedPlanId
                    },
                    success: function success() {
                        _logger.$logger.info('checkout_fpti', _extends({
                            from: 'CREATE_FI_AUTH',
                            to: 'process_fi_auth',
                            client_epoch_ts: Date.now()
                        }, fptiData));

                        return _angular.$q.when();
                    },
                    contingencies: {
                        CC_AUTHORIZATION_DECLINED: function CC_AUTHORIZATION_DECLINED() {
                            // For CC_AUTHORIZATION_DECLINED contingency retrieve the checkout session and
                            // 1. For Multi FI - Reload the xo-review page.
                            // 2. For Single FI - Redirect to Add Card contingency page.

                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: 'CC_AUTHORIZATION_DECLINED'
                            }, fptiData));

                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }

                            // Retrieve the checkout session before reloading the xo-review Page.
                            // as we need to get latest declineInstument in the session.
                            return $scope.checkoutSession.retrieve({
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    if ($scope.cancelUpdateListener) {
                                        $scope.cancelUpdateListener();
                                    }

                                    if (!$scope.selectFiVariant) {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                        return _squid.$promise.shortCircuit();
                                    }

                                    // Check that there is more than one plan to choose from, or that plan is not preferred
                                    var plans = $scope.checkoutSession.get('fundingOptions.plans');
                                    var isPreferredDefault = $scope.skipSelectFiVariants.indexOf($scope.choiceVariant) > -1 && plans && plans[0].primaryFs.isPreferred;
                                    var stickyPlans = $scope.checkoutSession.futurePaymentInstruments;
                                    var hasManyPlans = plans && plans.length > 1;
                                    var hasStickyPlans = stickyPlans && stickyPlans.length > 1;

                                    if (!isPreferredDefault && (hasManyPlans || hasStickyPlans)) {
                                        _uiRouter.$state.go('checkout.selectFi', { newState: true }, { reload: true });
                                    } else {
                                        _uiRouter.$state.go('checkout.review', { message: 'CC_AUTHORIZATION_DECLINED' }, { reload: true });
                                    }
                                    return _squid.$promise.shortCircuit();
                                },
                                contingencies: {
                                    NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                                        // for single FI scenario, if preAuth fails, we would need to redirect to
                                        // Add Credit card contingency page.
                                        _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                                        return _squid.$promise.shortCircuit();
                                    }
                                }
                            });
                        },
                        DEFAULT: function DEFAULT(name) {
                            // For any error / contingency other than CC_AUTHORIZATION_DECLINED, bypass it and move forward
                            // with Approve call.
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'CREATE_FI_AUTH',
                                to: 'process_fi_auth',
                                client_epoch_ts: Date.now(),
                                int_error_code: name
                            }, fptiData));
                            return _angular.$q.when();
                        }
                    }
                });
            } else {
                return _angular.$q.when();
            }
        };

        function authorize() {

            // making it as internal function to prevent calling directly
            function internalAuthorize() {
                return $scope.checkoutSession.action('authorize', {
                    batch: isGoogleAccountLinking && _tokenizedFactory.$TokenizedFactory.getAuthorizeBatch(),
                    data: {
                        alternateFundingOptionId: cardBackup && cardBackup.planId
                    },
                    success: function success() {
                        if ($scope.checkoutSession.get('plan.paypal_credit')) {
                            _logger.$logger.info('checkout_fpti', { 'ppc_reuse_status': 'success' });

                            // for PPC reuse radio banner testing we want to indicate whether the user selected PPC via radio button or banner.

                            _logger.$logger.info('checkout_fpti', {
                                from: 'clickPPCReuse',
                                to: 'radio_click'
                            });
                        }

                        var padToggleStatus = getPadToggleStatus();

                        if (padToggleStatus === 'ON') {
                            _logger.$logger.info('checkout_fpti', {
                                'pad_toggle_status': 'padToggleOnSuccess'
                            });
                        } else if (padToggleStatus === 'OFF') {
                            _logger.$logger.info('checkout_fpti', {
                                'pad_toggle_status': 'padToggleOffSuccess'
                            });
                        }

                        // for all tokenized flows except google account linking - log FPTI in authorize sucess callback
                        if (!isGoogleAccountLinking && $scope.checkoutCart.isWalletTokenization()) {
                            _tokenizedFactory.$TokenizedFactory.logProcessReviewToFPTI();
                        }

                        // Just in case, cancel the state change listener checking if updateFs needs to be called
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        if ($scope.checkoutSession.get('sepa_mandate.bankId')) {
                            return _uiRouter.$state.go('checkout.sepapage');
                        }

                        // xchild = V4 Incontext Integration. Do not initiate Payment.
                        if (!window.xchild && $scope.checkoutAppData.doec_on_approve()) {
                            return _uiRouter.$state.go('checkout.pay');
                        }

                        // for all flows except google account linking - go to end of checkout
                        // for google account linking - redirect happens in "updateIssuanceScope" call (see tokenizedFactory)
                        if (!isGoogleAccountLinking) {
                            return _uiRouter.$state.go('checkout.end');
                        }
                    },
                    contingencies: {
                        // Smart $x authorization check on the card fails
                        CREDIT_CARD_AUTH_FAILED: function CREDIT_CARD_AUTH_FAILED() {
                            _logger.$logger.info('checkout_fpti', _extends({
                                from: 'REVIEW',
                                to: 'process_review_err',
                                int_error_code: 'CREDIT_CARD_AUTH_FAILED'
                            }, cpaFptiData));
                            $scope.checkoutSession.invalidate();
                            $scope.checkoutSession.smartDollarAuthFailed = true;
                            if ($scope.checkoutSession.selectedFuturePaymentInstrument) {
                                // Invalidate the saved FI selection to avoid display of stale selection on review page.
                                delete $scope.checkoutSession.selectedFuturePaymentInstrument;
                            }
                            return $scope.checkoutSession.action('create', {
                                success: function success() {
                                    $scope.checkoutSession.smartDollarAuthFailed = false;
                                    $scope.errorHandlerHelper.addPageError('payment.authFailureMultipleFIs');
                                    return _uiRouter.$state.go('checkout.review', { message: 'CREDIT_CARD_AUTH_FAILED' });
                                }
                            });
                        }
                    }
                });
            }

            // 3DS 1.0 FI route to resolve
            if ($scope.checkoutSession.resolve_3ds) {
                _logger.$logger.info('3DS_v1_contingency_thrown');

                return show3DSLightbox();
            } else if ($scope.checkoutSession.threeDSResolutionData) {
                // 3DS ACE route data (call it as 3DSv2.0)
                // this is completely different set of APIs and data needs to be passed
                // grab them all from different source
                _logger.$logger.info('3DS_v2_contingency_thrown');
                return show3dsDDCLightBox();
            }

            function isXoonUpopRedirect() {
                if (!($scope.checkoutSession && $scope.checkoutSession.get('errorData.resolution.data.fi.type'))) {
                    return false;
                }

                return _squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' && $scope.checkoutSession.errorData.resolution.name === 'PAYER_TO_AUTHENTICATE_CARD' && !$scope.checkoutSession.errorData.resolution.data.alternate_options && $scope.checkoutSession.errorData.resolution.data.fi.type.toUpperCase() === 'CUP';
            }

            if ($scope.checkoutSession.unconfirmed_upop || isXoonUpopRedirect()) {
                var card = void 0;

                if ($scope.checkoutSession.unconfirmed_upop) {
                    card = $scope.checkoutSession.unconfirmed_upop;
                } else {
                    card = $scope.checkoutSession.errorData.resolution.data;
                }

                $scope.cardModel = new _fi.$AddCardModel({});
                $scope.cardModel.id = card.fundingId;
                $scope.cardModel.card = new _fi.$CardModel({
                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                    type: card.fi.type.toUpperCase(),
                    productType: card.fi.productType
                });
                _uiRouter.$state.go('.confirmUpop');
                return;
            }

            // Currently, exit message will only be applicable to US. If we'd like
            // to expand exit message feature to other countries, we will need
            // translation from other countries.
            if (applyExitMessage()) {
                // HACK - REMOVE and REFACTOR ONCE DONE
                // overload base.processing in strings
                // since quid is hardcoded to use string each time
                // required only for testing - remove and refactor,
                // to properly allow for dynamic spinner messages

                // resolve merchant name
                var merchantName = pxpMerchName;
                // flag when name is missing or longer than 20 chars
                var badMerchantName = !merchantName || merchantName.length > pxpMerchNameLimit;
                var outroMsg = badMerchantName ? 'We’re sending you back to the merchant to complete this purchase.' : 'We\u2019re sending you back to <strong style="white-space:nowrap">' + merchantName + '</strong> to complete this purchase.';

                // capture current route
                var reviewRoute = _uiRouter.$state.current;

                // listen to !startLoad
                // this is the only way we can then manipulate the spinner
                var cancelOutroOverride = _angular.$rootScope.$on('startLoad', function () {
                    // if this is the review route...
                    // this is needed, in case the session has ended
                    // at this point, we need this listener to do nothing
                    if (_uiRouter.$state.current === reviewRoute) {
                        // force spinner styling and content
                        // this is delayed, because (for some reason)
                        // the spinner isn't in the DOM _yet_,
                        // even though #showSpinner() fired... UGH!
                        (0, _angular.$timeout)(function () {
                            var spinnerMessageEl = (0, _jquery2['default'])('#spinner-message');

                            if (spinnerMessageEl) {
                                spinnerMessageEl = spinnerMessageEl.css({
                                    width: '130%',
                                    marginLeft: '-15%'
                                });
                                if (spinnerMessageEl) {
                                    // setting here, since `ng-bind-html` didn't work in spinner directive
                                    spinnerMessageEl.html(outroMsg);
                                }
                            }
                        }, 1);
                    } else {
                        // (otherwise) when no longer the review route...
                        // this means something happened before redirect
                        // likely an expired session
                        // In that case we'll remove this listener
                        // It will just be re-added, in the next redirect attempt
                        cancelOutroOverride();
                    }
                });

                _angular.$rootScope.$on('$destroy', cancelOutroOverride);
            }

            var cardBackup = $scope.checkoutSession.cardBackup.getPlan();

            _logger.$logger.info('checkout_fpti', {
                from: 'processor_decline_retry',
                to: 'processor_decline_retry_eligibility',
                'is_bkp_funding_chosen': cardBackup && cardBackup.planId ? 1 : 0
            });

            var isGoogleAccountLinking = _tokenizedFactory.$TokenizedFactory.isGoogleAccountLinking();

            // for Google account linking - make a batch call which includes "authorize" call first call
            // and updateIssuaceScope as second
            if (isGoogleAccountLinking) {
                _tokenizedFactory.$TokenizedFactory.updateIssuanceScope();
            }

            /**
             * now we have cleared all contingencies / error in  FI,
             * check for any pre-authorization required
             * possible usecases are CPA (Customer Present Auth)
             * and multi shipment payments (AS2 and BA flows), nothing to do anything with
             * shipping address / shipping amount , multi shipment means , multiple transaction allowed
             * using OrderId or Billing Agrement Id
             */
            var cpaFptiData = {};
            var selectedPlanId = decidePlanSelection() || getDefaultPlanId();
            var selectedPlan = getPlan(selectedPlanId);
            var _$scope$checkoutSessi3 = $scope.checkoutSession.payer;
            _$scope$checkoutSessi3 = _$scope$checkoutSessi3 === undefined ? {} : _$scope$checkoutSessi3;
            var payerId = _$scope$checkoutSessi3.id;
            // if the selected or default plan requires auth

            if (_sharedUtil.$SharedUtil.isSelectedPlanRequiresAuth(selectedPlan)) {
                cpaFptiData = {
                    fi_id: selectedPlan && selectedPlan.primaryFs ? selectedPlan.primaryFs.id : '',
                    plan_id: selectedPlanId,
                    buyer_id: payerId,
                    ryp_button_text: $scope.useraction === 'commit' ? 'PayNow' : 'Continue',
                    client_epoch_ts: Date.now()
                };

                _logger.$logger.info('checkout_fpti', _extends({
                    from: 'REVIEW',
                    to: 'process_review'
                }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession, isProcessTransition: true }), cpaFptiData));

                // ok, we need to do preauthorize now, before making actual authorize
                return preAuthorize().then(function () {
                    return internalAuthorize();
                });
            } else {
                // if plan  doesn't require any auth - continue with auth
                return internalAuthorize();
            }
        }

        function setShowShippingMethodProperty() {
            return (0, _squid.$populate)($scope, {
                shippingRulesSummary: _shippingMethod.$ShippingRuleSummaryModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        merchant_id: $scope.payee.get('merchant.id'),
                        currency_code: $scope.checkoutCart.get('purchase.amounts.total.currency_code')
                    }
                })
            }).then(function () {
                if ($scope.shippingRulesSummary.isSnTEnabled) {
                    _logger.$logger.info('shipping_rules_summary_snt_enabled');
                } else {
                    _logger.$logger.info('shipping_rules_summary_snt_disabled');
                }
                $scope.showShippingMethod = $scope.shippingRulesSummary.isSnTEnabled || $scope.isInstantUpdateAPIFlow;
                return;
            });
        }

        function show3DSDeclineMsg(declineAfter3DSAccept) {
            // Instrument number of available plans for 3DS decline case.
            var numberOfPlans = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : 0;

            _logger.$logger.info('3DS_decline_plan_count', { 'plans': numberOfPlans });

            var key = 'threeDS.memberDecline';

            if (declineAfter3DSAccept) {
                key = 'threeDS.memberDeclineAfter3DSAccept';
            }

            // extract card information from 3DS V1 contingency context
            var card = $scope.checkoutSession && $scope.checkoutSession.resolve_3ds;

            // extract card information from 3DS V2 contingency context
            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref6 = threeDSResolutionData && threeDSResolutionData.resolutions || [],
                resolutions = _ref6[0];

            var _ref7 = resolutions || {},
                _ref7$funding_instrum = _ref7.funding_instrument_details;

            _ref7$funding_instrum = _ref7$funding_instrum === undefined ? {} : _ref7$funding_instrum;
            var _ref7$funding_instrum2 = _ref7$funding_instrum.payment_card,
                payment_card = _ref7$funding_instrum2 === undefined ? {} : _ref7$funding_instrum2;

            // consider V1 or V2 card data

            var cardInformation = card || payment_card;

            if (cardInformation) {
                var msg = (0, _squid.$renderContent)(key, {
                    cardType: cardInformation.type,
                    last4: cardInformation.number
                });

                $scope.checkoutSession.message = {
                    msgs: [msg],
                    type: 'warning'
                };
            }
        }

        /**
         * call patchXO API to clear the 3DS contingency and then call authorize API.
         */
        function clear3DSContingency() {
            _logger.$logger.info('3DS_v1_clear_contingency');
            var resolve_3ds = $scope.checkoutSession.resolve_3ds || {};

            return $scope.checkoutSession.action('clear3DSContingency', {
                data: {
                    ccId: resolve_3ds.ccId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.resolve_3ds) {
                        return authorize();
                    } else {
                        // Symphony is not able to clear the 3DS contingency
                        show3DSDeclineMsg(true);
                    }
                }
            });
        }

        /*
         * call to update the three ds status into checkout session
         * unlike 3DS V1 , we need to update the status with reference Id
         * 3DS reference id, and lookup or authenticaton id needs to passed
         * at the time of fulfillment
         */
        function updatethreedsStatus(status, threeDSTransactionId) {
            _logger.$logger.info('3DS_v2_clear_contingency');

            var threeDSResolutionData = $scope.checkoutSession.get('threeDSResolutionData');

            var _ref8 = threeDSResolutionData.resolutions || [],
                resolutions = _ref8[0];

            var _ref9 = resolutions || {},
                _ref9$funding_instrum = _ref9.funding_instrument_details;

            _ref9$funding_instrum = _ref9$funding_instrum === undefined ? {} : _ref9$funding_instrum;
            var _ref9$funding_instrum2 = _ref9$funding_instrum.payment_card,
                payment_card = _ref9$funding_instrum2 === undefined ? {} : _ref9$funding_instrum2,
                _ref9$funding_instrum3 = _ref9$funding_instrum.three_ds_contingency_context,
                three_ds_contingency_context = _ref9$funding_instrum3 === undefined ? {} : _ref9$funding_instrum3;

            // pass below information to blacklist if any of the 3DS resolution failed

            var cc_id = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
            var card_number = payment_card.number;
            var card_type = payment_card.type;
            var referenceId = three_ds_contingency_context.reference_id;

            return $scope.checkoutSession.action('clear3DSContingency', {
                resultModel: $scope.checkoutSession,
                data: {
                    ccId: cc_id,
                    status: status !== 'SUCCESS' ? 'FAILURE' : status,
                    authId: threeDSTransactionId,
                    referenceId: referenceId
                },
                success: function success() {
                    // Clear3DSContingency can change the plan ids, so reset the multipleFi indicator after this is called
                    if ($scope.setupMultipleFi) {
                        $scope.setupMultipleFi();
                    }

                    if (!$scope.checkoutSession.threeDSResolutionData && status === 'SUCCESS') {
                        // if checkout session not having contingency and if 3DS success, continue with authorize
                        return authorize();
                    } else {
                        // Symphony might blacklist the earlier failed instrument
                        // inform about this with a error message
                        _logger.$logger.info('3DS_v1_black_listed_instrument');
                        var key = 'threeDS.memberDecline';

                        if (card_number) {
                            var msg = (0, _squid.$renderContent)(key, {
                                cardType: card_type,
                                last4: card_number
                            });

                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                    }
                }
            });
        }

        $scope.onComplete3DSHandler = function (status) {
            $scope.launch3DSResolver = false;
            if (status === 'success') {
                return clear3DSContingency();
            } else if (status === 'decline') {
                // 3DS got declined
                show3DSDeclineMsg();
            }
        };

        $scope.isOptionalVaulting = function () {
            var optionalVaulting = false;
            if ($scope.checkoutCart.billing && $scope.checkoutCart.billing.save_paypal_as_option && _squid.$config.baOptOutEnabledCountries.indexOf(_squid.$locale.country) > -1) {
                optionalVaulting = true;
            }
            return optionalVaulting;
        };

        $scope.getOptInContent = function () {
            var key = 'billingAgreement.bal' + ($scope.eligibleToHoldBalance ? 'Eligible' : 'Ineligible') + 'Vault' + ($scope.vault.checked ? 'Optin' : 'Optout');
            return (0, _squid.$renderContent)(key, { merchantName: $scope.merchantName, country: _squid.$locale.country, lang: _squid.$locale.lang });
        };

        $scope.changeVaultSelection = function () {
            _logger.$logger.info('optional_vault_user_selection_' + $scope.vault.checked);
        };

        $scope.onCompletethreedsHandler = function (status, transactionId) {
            $scope.showThreedsPopup = false;
            // safely convert the status
            if (status.toLowerCase() === 'success') {
                return updatethreedsStatus(status, transactionId.threeDSTransactionId);
            } else {
                // display 3DS decline message
                show3DSDeclineMsg();
            }
        };

        $scope.upopCallbacks = {
            onConfirmUpopSuccess: function onConfirmUpopSuccess() {
                _uiRouter.$state.go('checkout.review');
                return $scope.checkoutSession.action('clearContingency', {
                    data: {
                        contingency: 'UNCONFIRMED_UPOP',
                        ccId: $scope.checkoutSession.get('unconfirmed_upop.fundingId') || $scope.checkoutSession.get('errorData.resolution.data.fundingId')
                    },
                    success: function success() {
                        if (!$scope.checkoutSession.unconfirmed_upop) {
                            return authorize();
                        } else {
                            $scope.checkoutSession.message = {
                                type: 'warning',
                                msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                            };
                        }
                    }
                });
            },
            onConfirmUpopCancel: function onConfirmUpopCancel() {
                _uiRouter.$state.go('checkout.review');
                $scope.showUnconfirmedUpopMsg = false;
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['confirmUpop.confirmUpopOrChooseAltMethod']
                };
            }
        };

        $scope.errorHandlerHelper = {};
        $scope.errorHandlerHelper.addPageError = function (contentKey, dynamicValuesInContent) {
            var messages = [];
            var msg = void 0;

            if (dynamicValuesInContent) {
                msg = (0, _squid.$renderContent)(contentKey, dynamicValuesInContent);
            } else {
                msg = _squid.$locale.content.get(contentKey);
            }

            messages.push(msg);
            $scope.checkoutSession.message = {
                msgs: messages,
                type: 'error'
            };
        };

        $scope.errorHandlerHelper.clearPageErrors = function () {
            $scope.checkoutSession.message = '';
        };

        $scope.returnFromCape = function (isCapeReturnKey) {

            return $scope.creditDataModel.action('readCreditKey', {
                data: {
                    capeKey: isCapeReturnKey
                },
                success: function success(res) {
                    // if CAPE includes this field inside the mayfly payload, we will show-up a warning message
                    // on the top of the page ('offers.bmlInWalletDeniedMsg') regarding the declined credit application
                    if (res.show_cape_declined_msg) {
                        $scope.checkoutSession.message = {
                            type: 'warning',
                            msgKeys: ['offers.bmlInWalletDeniedMsg']
                        };
                    }
                    // TODO: We want to remove this condition and make the two calls in parallel.
                    if (res.financial_instrument_id) {
                        var financial_instrument_id = res.financial_instrument_id.indexOf('BC') !== 0 ? 'BC' + res.financial_instrument_id : res.financial_instrument_id;

                        if (res.financial_instrument_details) {
                            return $scope.creditOptions.action('select', {
                                data: Object.assign({}, res.financial_instrument_details, { nominal_rate: undefined }),
                                success: function success() {
                                    $scope.installment.financing_details = res.financial_instrument_details;
                                    $scope.installment.showCYCO = false;

                                    if (_squid.$locale.country === 'DE' && res.credit_account_id) {
                                        return $scope.checkoutSession.fundingOptions.action('add', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                financialInstrumentID: financial_instrument_id,
                                                creditAccountID: res.credit_account_id,
                                                creditProductType: 'BILL_ME_LATER'
                                            },
                                            success: function success(result) {
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    } else {
                                        return $scope.checkoutSession.fundingOptions.action('update', {
                                            resultModel: $scope.checkoutSession,
                                            data: {
                                                planId: financial_instrument_id
                                            },
                                            success: function success(result) {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                                if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                                    $scope.checkoutSession.message = {
                                                        type: 'success',
                                                        msgKeys: ['offers.bmlInWalletSuccessMsg']
                                                    };
                                                }
                                                if ($scope.setupMultipleFi) {
                                                    $scope.setupMultipleFi();
                                                }
                                            },
                                            error: function error() {
                                                $scope.creditDataModel.setReturnFromCapeComplete(true);
                                            }
                                        });
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        } else {
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                data: {
                                    planId: financial_instrument_id
                                },
                                success: function success(result) {
                                    if ($scope.creditOptions.creditType === 'INST' && $scope.creditOptions.paypalSubsidy && (_squid.$locale.country === 'US' || _squid.$locale.country === 'GB')) {
                                        // This will prevent users from seeing GPL RYI details when PPC FI is selected, this issue was being caused by GPL in-house installments
                                        delete $scope.creditOptions.creditType;
                                    }
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                    if (_squid.$locale.country !== 'DE' && $scope.isCapeReturnApproval && !res.is_reuse) {
                                        $scope.checkoutSession.message = {
                                            type: 'success',
                                            msgKeys: ['offers.bmlInWalletSuccessMsg']
                                        };
                                    }
                                    if ($scope.setupMultipleFi) {
                                        $scope.setupMultipleFi();
                                    }
                                },
                                error: function error() {
                                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                                }
                            });
                        }
                    } else {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        // User does not have any FI in wallet and they choose to pay in full.
                        if (!$scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.isCreditPromoted) {
                            _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard');
                        } else if ($scope.creditDataModel.isCapeInternalServiceError()) {
                            // Todo Show error message from CAPE
                            return _angular.$q.when();
                        } else {
                            return _angular.$q.when();
                        }
                    }
                },
                error: function error() {
                    $scope.creditDataModel.setReturnFromCapeComplete(true);
                },
                contingencies: {
                    DEFAULT: function DEFAULT(name, err) {
                        $scope.creditDataModel.setReturnFromCapeComplete(true);
                        _logger.$logger.info('read_cape_key_failure');
                        return _angular.$q.when();
                    }
                }
            });
        };

        var ifPadThenUpdatePlan = function ifPadThenUpdatePlan(selectedMethodPlanId) {
            // For pad toggle feature with Choice Multi FI experience, we look up the plan ID here
            var padOrIachPlanId = _factory8.$PADFactory.isPadToggleFeatureApplicable($scope.padToggleFeature, $scope.isPadToggleEnabled) && _factory8.$PADFactory.getPadOrIachBankPlanId({
                selectedMethodPlanId: selectedMethodPlanId,
                fundingOptions: $scope.checkoutSession.fundingOptions,
                multiFiCheckboxStates: $scope.padToggleFeature.multiFiCheckboxStates
            });

            return padOrIachPlanId ? padOrIachPlanId : selectedMethodPlanId;
        };

        /**
         *  Decides the plan to use based on
         *  Pad, Credit, Rewards and any other
         *  bussiness logic
         *
         * @returns planID
         */
        var decidePlanSelection = function decidePlanSelection() {
            // TODO: Consider moving this to a generic wallet/plan factory
            // this will avoid repetition in RYI, SelectFI and PayWith
            var defaultPlan = $scope.checkoutSession.get('plan.sources') && $scope.checkoutSession.get('plan.sources')[0];
            var hasRewards = _factory3.$RewardsCheckboxFactory.isRewardsPlan($scope.checkoutSession.plan);
            var selectedMethodPlanId = (0, _utils.getSelectedPlan)($scope.selectedmethod, $scope.checkoutSession);

            if (!$scope.selectedmethod && !hasRewards) {
                return '';
            }

            selectedMethodPlanId = ifPadThenUpdatePlan(selectedMethodPlanId);
            selectedMethodPlanId = _factory3.$RewardsCheckboxFactory.ifRewardsThenUpdatePlan(selectedMethodPlanId, $scope.selectedmethod, $scope.checkoutSession);

            // If the plan is already selected, we don't need to duplicate the call
            if (selectedMethodPlanId === (defaultPlan && defaultPlan.id)) {
                return '';
            }

            // This is handled in onPay
            if (selectedMethodPlanId === 'applyForPPCRadio') {
                return '';
            }
            return selectedMethodPlanId;
        };

        /**
         *  Given a plan id perform a selection
         *  and handle any errors/contingencies
         *
         * @returns planID
         */
        var doPlanSelection = function doPlanSelection(selectedMethodPlanId) {
            return $scope.checkoutSession.fundingOptions.action('select', {
                data: {
                    planId: selectedMethodPlanId
                },
                success: function success(result) {
                    $scope.checkoutSession.populate(result);

                    // for multi fi use case after replan we need to reset index to 0
                    // since selected instrument will always be first
                    if ($scope.selectedmethod) {
                        $scope.selectedmethod.index = 0;
                    }

                    // Double check on PayPal balance eligibility after CheckoutSession re-plan
                    return _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                        return shouldEnableBalance(currentState);
                    });
                },
                contingencies: {
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, result) {
                        // Route to the Confirm Upop page
                        if (result && result.resolution) {
                            var card = result.resolution.data;

                            if (card.fundingId && card.fi && card.fi.type) {
                                $scope.cardModel = new _fi.$AddCardModel();
                                $scope.cardModel.id = card.fundingId;
                                $scope.cardModel.card = new _fi.$CardModel({
                                    number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                                    type: card.fi.type.toUpperCase(),
                                    productType: card.fi.productType
                                });
                            }
                        }

                        // Before routing to confirm Upop route, we cancel the state change listener so that we don't call updateFS. At this point, the user has already made their selection, so this is unneeded.
                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Route to the Confirm Upop page. We'll hold on to this deferred promise until the confirmation flow is finished, so we can then continue the chain or cancel out
                        var upopResult = _angular.$q.defer();

                        // Create the handlers for Upop, specifically for this flow. They will act on the deferred promise when the flow is completed
                        $scope.upopCallbacks.isOnUpdate = true;
                        $scope.upopCallbacks.onUpdateSuccess = function () {
                            // On confirmed, update the checkout session then continue
                            return $scope.checkoutSession.fundingOptions.action('update', {
                                resultModel: $scope.checkoutSession,
                                silent: true,
                                data: {
                                    planId: $scope.cardModel.id
                                },
                                success: function success() {
                                    if ($scope.checkoutSession.cvvData) {
                                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardModel.get('card.security_code'));
                                    }

                                    // Reset the callback flag
                                    $scope.upopCallbacks.isOnUpdate = false;
                                    $scope.setupMultipleFi();
                                    // Return to this route, resolve the promise
                                    _uiRouter.$state.go('checkout.review');
                                    upopResult.resolve();
                                }
                            });
                        };
                        $scope.upopCallbacks.onUpdateCancel = function () {
                            // Break the promise chain and return to the review page
                            $scope.upopCallbacks.isOnUpdate = false;
                            $scope.setupMultipleFi();
                            upopResult.reject();
                            $scope.upopCallbacks.onConfirmUpopCancel();
                        };

                        _uiRouter.$state.go('.confirmUpop');
                        return upopResult.promise;
                    }
                }
            });
        };

        // For the multiple FI variant of the choice experiment:
        // Update the funding option in the plan based on the user's stored selection
        var updateFS = function updateFS() {
            // Decide plan to select based on priority and bussness logic
            var selectedMethodPlanId = decidePlanSelection();

            // Perform a selection only if required
            return selectedMethodPlanId ? doPlanSelection(selectedMethodPlanId) : _angular.$q.when();
        };

        var getBalanceEligibility = function getBalanceEligibility() {
            return _user.$UserEligibleToHoldBalanceModel.instance().retrieve().then(function (res) {
                var eligibleToHoldBalance = res && res.eligibleToHoldBalance;
                _logger.$logger.info('balance_eligibility_STATUS', { eligibleToHoldBalance: eligibleToHoldBalance });
                return eligibleToHoldBalance;
            })['catch'](function () {
                _logger.$logger.info('balance_eligibility_STATUS_CHECK_ERROR');
                return false;
            });
        };

        // The following functions are all used in the `$q.all` promise chain below
        var populateScope = function populateScope() {
            return (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token).retrieve(),
                fiMeta: _index4['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
            }).then(function () {
                // set the cpa eligible to get used  in review page to display CPA  error message and etc
                $scope.isCPAEligible = _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI($scope.checkoutSession) || _sharedUtil.$SharedUtil.isAuthDeclinedInstrument($scope.checkoutSession);
            }).then(function () {
                return $scope.isOptionalVaulting() && getBalanceEligibility().then(function (eligibleToHoldBalance) {
                    $scope.eligibleToHoldBalance = eligibleToHoldBalance;
                });
            });
        };

        /* Flag to determine whether merchant supports callback shipping options for given address
         1. Default : true
         2. shippingRegionSupported : false -> Show shipping region not supported error in review page and do not allow Pay
         */
        $scope.instantUpdateFeature = {
            shippingRegionSupported: true
        };
        $scope.shippingChangeFeature = {};

        var initAndCallOnShippingChange = function initAndCallOnShippingChange() {
            $scope.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
                orderID: $scope.token,
                checkoutCart: $scope.checkoutCart,
                checkoutSession: $scope.checkoutSession,
                checkoutAppData: $scope.checkoutAppData,
                callbackFn: function callbackFn() {
                    /*
                      This function gets called after the onShippingChange
                      function is called on the merchant's page.
                    */
                    $scope.checkoutSession.reload().then(function () {
                        return $scope.checkForShippingOptions();
                    });
                }
            });

            $scope.shippingChangeFeature.callOnShippingChange();
        };

        var initializePadToggleSupport = function initializePadToggleSupport() {
            if ($scope.checkoutSession.fundingOptions.isPadToggleApplicable()) {
                return Experiments.padToggleFeatureSupported().then(function (result) {
                    $scope.isPadToggleEnabled = result;
                });
            } else {
                return _angular.$q.when($scope.isPadToggleEnabled = false);
            }
        };

        var applyChoiceExperimentVariant = function applyChoiceExperimentVariant() {
            $scope.tagFamilyComputer();
            // Get the choice experiment variant to determine what needs to be shown in the UI
            return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                $scope.choiceVariant = variant;
                var checkboxVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.preferredCheckbox || [];
                var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];
                var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                $scope.skipSelectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.skipSelectFi || [];

                if (checkboxVariants.indexOf(variant) !== -1 && !$scope.checkoutCart.isBilling() && !$scope.checkoutCart.referenceCheckout) {
                    // Do setup for preferred checkbox
                    $scope.makeFiPreferred = {
                        selected: false
                    };
                }

                $scope.showMultipleFiVariants = multipleFiVariants.indexOf(variant) !== -1;

                if ($scope.showMultipleFiVariants) {
                    // Do the setup for the multipleFiVariant
                    $scope.setupMultipleFi = function () {
                        var planList = $scope.checkoutSession.get('plan.sources');
                        var defaultPlanId = planList && planList[0] && planList[0].id;
                        $scope.selectedmethod = {
                            index: 0,
                            planId: defaultPlanId
                        };

                        if ($scope.cancelUpdateListener) {
                            $scope.cancelUpdateListener();
                        }

                        // Before changing state, persist the change that the user selected
                        var stateChangeListener = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
                            $scope.cancelUpdateListener();

                            // ensure we only listen to state changes initiated from the review page
                            if (_uiRouter.$state.fromState.name !== 'checkout.review') {
                                return;
                            }

                            // ignore if the FI selection hasn't been updated
                            if (defaultPlanId === $scope.selectedmethod && $scope.selectedmethod.planId) {
                                return;
                            }

                            event.preventDefault();
                            updateFS().then(function () {
                                return _uiRouter.$state.go(toState, toParams);
                            });
                        });

                        // If the checkout session changes, also change the planId according to the selected index in case plan ids were changed. Save the listener to destroy the handler when changing routes or re-calling setupMultipleFi
                        var fundingOptionsListener = $scope.$watch('checkoutSession.fundingOptions', function (newVal, oldVal) {
                            if (!newVal) {
                                return;
                            }

                            $scope.selectedmethod.planId = newVal.get('plans.' + $scope.selectedmethod.index + '.planId');
                        });

                        $scope.cancelUpdateListener = function () {
                            stateChangeListener();
                            fundingOptionsListener();
                        };

                        $scope.$on('$destroy', $scope.cancelUpdateListener);
                    };

                    $scope.setupMultipleFi();
                }

                $scope.selectFiVariant = selectFiVariants.indexOf(variant) !== -1;

                if ($scope.isProcessorDeclineExperiment && $scope.selectFiVariant) {
                    $scope.hideBlacklistMsg = true;
                }
                // If there are decline instrument and customer is eligible for CPA, we dont want to show any existing message to user.
                // instead CPA message would be shown. A separate component 'decline-notification' has been created for this.
                if ($scope.isCPAEligible && $scope.checkoutSession.declinedInstruments && $scope.checkoutSession.declinedInstruments.length) {
                    $scope.hideBlacklistMsg = true;
                }
            })['catch'](function (err) {
                // TODO: Check what happens to PXP errors
                _logger.$logger.error('choice_eligibility_error', err);
            });
        };

        var applyMerchantName = function applyMerchantName() {
            // resolve merchant name now, just in case we're in a matching treatment
            pxpMerchName = $scope.checkoutAppData.merchant.brand_name || $scope.checkoutAppData.merchant.merchant_name;
        };

        // Set the checks to allow the checkout button to be clicked
        $scope.showMissingShippingOptionMessage = false;
        $scope.showMissingPickupOptionMessage = false;

        // if IXO is providing shipping methods, we'll send them to xo-shipping-options component
        $scope.checkForShippingOptions = function () {
            return (0, _xoShippingOptions.getShippingOptions)($scope.token).then(function (options) {
                _logger.$logger.info('new_options_loaded', { options: options });
                $scope.shippingOptions = options;
            }).then(function () {
                return (0, _xoShippingOptions.getSelectedShippingOption)($scope.token);
            }).then(function (selectedOption) {
                _logger.$logger.info('new_option_selected', { selectedOption: selectedOption });
                $scope.selectedShippingOption = selectedOption;
            });
        };

        $scope.selectShippingOption = function (option, checkShippingWarn, checkPickupWarn) {
            $scope.showMissingPickupOptionMessage = checkPickupWarn;
            $scope.showMissingShippingOptionMessage = checkShippingWarn;

            if (!option) {
                return;
            }

            return (0, _xoShippingOptions.selectShippingOption)($scope.token, option).then(function () {

                // If the merchant is integrated with
                // the Callback API, let's call it and then
                // replan through that flow

                if ((0, _shippingChangeFeature.hasOnShippingChangeCallback)()) {
                    return $scope.shippingChangeFeature.callOnShippingChange();
                }

                return _angular.$q.when();
            });
        };

        /**
         * Set up $watch for if `showMore` button has been clicked.
         * When `showMore` button has been clicked, we also need to
         * log all FIs that has a cardart FI
         */
        $scope.$watch(function () {
            return _factory4.$ShowMoreFiFactory.get().isShowMoreBtnClicked;
        }, function (clickedMore) {
            // ensure `showMore` button has been clicked for 3FIs pxp
            if (clickedMore) {
                logSessionDetails();
            }
        });

        var showGAC = function showGAC() {
            _factory.$GiveAtCheckoutFactory.decideEligibility().then(function (result) {
                $scope.isDonation = _factory.$GiveAtCheckoutFactory.get().eligible;
                var charity = _factory.$GiveAtCheckoutFactory.get().charity;

                if (_factory.$GiveAtCheckoutFactory.get().eligible) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'GIVE_AT_CHECKOUT',
                        to: 'prepare_give_at_checkout',
                        gac_model: charity.model_id,
                        gac_npid: charity.nonprofit_id
                    });
                }
            });
        };

        /**
         * Cardart instrumentation for review page comes in a few variations, and
         * it all depends on the pxp result. Following logSessionDetails()
         * logs cardart instrumentation based on:
         *
         * - showMultipleFiVariants pxp
         * - showMultipleFiVariants + 3FI pxp
         * - singleFI pxp
         *
         * See $CardArtInstrument.createPayload() for detailed implementation & explanation
         */
        var logSessionDetails = function logSessionDetails() {
            var isCardArtExp = _cardartInstrument.$CardArtInstrument.isCardArtEnable($scope.fiMeta) && !$scope.isThirdPartyWalletExperience();
            var renderMultipleFi = $scope.showMultipleFiVariants;
            var isBillingNoPurchase = $scope.checkoutCart.isBillingNoPurchase();
            var isBilling = $scope.checkoutCart.isBilling();
            var disableStickyForMerchant = _squid.$config.disableMerchantForStickyBA.indexOf($scope.payee.get('merchant.id')) > -1;
            var stickyEligible = isBilling && !disableStickyForMerchant;

            _logger.$logger.info('checkout_fpti', _extends({
                from: 'REVIEW',
                to: 'prepare_review'
            }, createReviewFptiPayload({ checkoutSession: $scope.checkoutSession }), isCardArtExp ? _cardartInstrument.$CardArtInstrument.createPayload({
                stickyEligible: stickyEligible,
                isBillingNoPurchase: isBillingNoPurchase,
                renderMultipleFi: renderMultipleFi,
                checkoutSession: $scope.checkoutSession,
                renderSingleFi: !$scope.showMultipleFiVariants,
                showMoreFiState: _factory4.$ShowMoreFiFactory.get()
            }) : null));
            // Log details about checkout session
        };

        // Reg E - Regulation E compliance guide mandates invoicing payers see a disclaimer message during payment review when RTR is present.
        // The Remittance Transfer Rule (RTR) is a rule published by the Consumer Financial Protection Bureau.
        // It applies to companies processing remittance transfers of more than $15 USD from a US-based consumer (Sender) to a foreign-based receiver (Recipient).
        var applyInvoicingRegEDetails = function applyInvoicingRegEDetails() {
            // Show invoicing RegE compliance message if its invoicing flow only and if RTR is present
            $scope.showInvoicingRegEMsg = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            _logger.$logger.info('show_invoicing_regE_msg', $scope.showInvoicingRegEMsg);

            if ($scope.showInvoicingRegEMsg) {
                var totalAmount = $scope.checkoutCart.purchase.amounts.total.amount_formatted_currency;
                var merchantName = $scope.checkoutAppData.merchant.brand_name;

                // The RegE message differs for cases with and without currency conversion
                if ($scope.checkoutSession.plan.hasConversion()) {
                    var total = 0;
                    var planSources = $scope.checkoutSession.get('plan.sources');
                    var currencyCode = planSources[0].amount.currency_code;

                    planSources.forEach(function (source) {
                        if (currencyCode !== source.amount.currency_code) {
                            $scope.showInvoicingRegEMsg = false;
                            return;
                        }

                        total = total + Number(source.amount.amount);
                    });

                    var totalInvoicePaymentAmount = (0, _squid.formatCurrency)(total, currencyCode);

                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsgWithCurrConv', {
                        merchantName: merchantName,
                        amountInPayerCurrency: totalInvoicePaymentAmount,
                        amountInInvCurrency: totalAmount
                    });
                } else {
                    $scope.invoicingRegEMsg = (0, _squid.$renderContent)('memberReview.invRegEMsg', {
                        merchantName: merchantName,
                        amount: totalAmount
                    });
                }
            }
        };

        // method to decide to show RTR language toggle
        var showLanguageToggleForRTR = function showLanguageToggleForRTR() {
            // get details about invoice and RTR decision
            var isRTRFlow = $scope.checkoutAppData.flags.is_invoice_flow && $scope.checkoutSession.showRemittanceDisclosure ? true : false;

            if (isRTRFlow) {
                if ($scope.checkoutSession.plan.hasConversion()) {
                    /**
                     * if RTR flow - compliance ask is to show a language toggle to switch
                     * between english and buyer's profile language (if both are english ignore showing this toggle)
                     */
                    var languageIgnoreToggle = 'en';
                    if (_squid.$locale.lang !== languageIgnoreToggle) {
                        _logger.$logger.info('show_invoicing_language_toggle', $scope.showInvoicingRegEMsg);
                        $scope.showRTRLanguageToggle = true;
                        $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                            language: (0, _squid.$renderContent)('languages.' + languageIgnoreToggle).toString()
                        });
                    }
                }
            }
        };

        // method to reload the page with selected locale
        $scope.reloadPageLanguageToggle = function () {
            if (_squid.$locale.lang === 'en') {
                _logger.$logger.info('rtr_toggle_to_' + $scope.buyerProfileLanguage);
                _squid.$locale.change(_squid.$locale.country, $scope.buyerProfileLanguage);
                applyInvoicingRegEDetails();
            } else {
                _logger.$logger.info('rtr_toggle_to_en');
                _squid.$locale.change(_squid.$locale.country, 'en');
                applyInvoicingRegEDetails();
            }
        };

        // method to change the RTR localized content - call for every locale change
        function changeRTRContent() {
            if (_squid.$locale.lang === 'en') {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.' + $scope.buyerProfileLanguage).toString()
                });
            } else {
                $scope.rtrContent = (0, _squid.$renderContent)('memberReview.rtrLanguageToggle', {
                    language: (0, _squid.$renderContent)('languages.en').toString()
                });
            }
        }
        $scope.$on('localeChange', changeRTRContent);

        var applyKmliUpsellEligibility = function applyKmliUpsellEligibility() {
            if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon') {
                var fiModel = $scope.checkoutSession.get('plan.sources');

                if (fiModel && fiModel.length && fiModel[0].card_type === 'CHINA_UNION_PAY') {
                    $scope.checkoutSession.message = {
                        msgKeys: ['confirmUpop.confirmUpopToPay'],
                        type: 'warning'
                    };
                }
            }

            _kmliUpsell.$KmliUpsell.eligible().then(function (eligibility) {
                eligibility.interstitial = eligibility.interstitial ? eligibility.interstitial : {};
                $scope.optin_toggle.isEnabled = eligibility.banner;
                $scope.optin_toggle.value = $scope.auth.rememberedOT() // came in as OneTouch user
                || $scope.auth.isKmliSet // used to set toggle value via interstial
                || $scope.auth.loggedIn() && $scope.auth.refreshToken(); // FirstTime OT (check this for webview case)
                delete $scope.auth.isKmliSet;

                $scope.optin_toggle.showExpandedTerms = false; // collapse by default;
                var cookiePayload = {};

                if (eligibility.interstitial.eligible) {
                    // show optin interstitial only once per user per version
                    cookiePayload.ot_inter_shown = eligibility.interstitial.pxpVersion; // cookieList.push({ name: 'ot_inter_shown', value: eligibility.interstitial.pxpVersion });
                }
                if (Object.keys(cookiePayload).length > 0) {
                    $scope.auth.action('updateAuthExperience', {
                        silent: true,
                        data: cookiePayload
                    }).then(function (res) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_success', res);
                    })['catch'](function (err) {
                        _logger.$logger.debug('optin_toggle_cookie_drop_err', err);
                    });
                }
                _logger.$logger.info('optin_toggle_init', $scope.optin_toggle);
            });

            $scope.personalizedBanner.trigger();
            $scope.showRemittanceDisclosure = _index2.$DeviceInfo.isMobile() && $scope.checkoutSession.showRemittanceDisclosure ? true : false;
        };

        // applyCreditOptions could potentially redirect out of the RYI.
        var applyCreditOptions = function applyCreditOptions() {
            $scope.creditDataModel = _credit.$CreditDataModel.instance($scope.token);
            var isChangeInstallments = $scope.creditDataModel.isChangeStatus();
            var isCapeReturnKey = $scope.creditDataModel.getCapeKey();
            var isCapeReturn = isCapeReturnKey && _squid.$util.param('success');

            // value of success url param is true indicates user was approved
            $scope.isCapeReturnApproval = isCapeReturnKey && _squid.$util.param('success') === 'true';

            if (isChangeInstallments) {
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            }
            if (isCapeReturn) {
                $scope.returnFromCape(isCapeReturnKey);
            }

            if (((0, _squid.$feature)('creditInstallmentOffers') || _squid.$locale.country === 'DE') && ($scope.checkoutSession.get('plan.paypal_credit') || isCapeReturnKey)) {
                $scope.creditOptions = _credit.$CreditInstallmentModel.instance($scope.token);
                $scope.creditOptions.retrieve().then(function () {
                    if ($scope.creditOptions.totalPayment) {
                        $scope.installment.financing_details = {
                            apr: $scope.creditOptions.apr,
                            credit_type: $scope.creditOptions.creditType,
                            monthly_payment: $scope.creditOptions.monthlyPayment,
                            term: $scope.creditOptions.term,
                            total_cost: $scope.creditOptions.totalPayment,
                            total_interest: $scope.creditOptions.totalInterest,
                            currency: $scope.cartCurrency
                        };
                    }
                    $scope.creditOptions.apr = String($scope.creditOptions.apr);
                });
            }

            $scope.cartCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');

            // this function returns true if plan sources contains exactly PPCredit & Incentive
            $scope.isCreditIncentiveOption = function () {
                var plans = $scope.checkoutSession.get('plan.sources', null);

                if (plans && plans.length === 2 && plans.filter(function (fi) {
                    return fi.type === 'BILL_ME_LATER';
                }).length === 1 && plans.filter(function (fi) {
                    return fi.type === 'INCENTIVE';
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            $scope.isPPCReuseAndNotSelected = function () {
                var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);
                if (plans && plans.filter(function (fi) {
                    return fi.name === 'BILL_ME_LATER' && !fi.selected;
                }).length === 1) {
                    return true;
                } else {
                    return false;
                }
            };

            // Tracking customers preferences for using PPC if it is a preferred FI
            var preferred_plan = $scope.checkoutSession.fundingOptions.getPreferred();
            _logger.$logger.info('checkout_fpti', {
                from: 'REVIEW_PREFERRED_FI',
                pref_fi_option_shown: preferred_plan && preferred_plan.primaryFs && preferred_plan.primaryFs.name
            });

            // if PPCredit & Incentive are showing in the page together with installments we will hide installment details
            $scope.showInstallmentOptionWithoutIncentives = function () {
                if ($scope.creditOptions.creditType === 'INST') {
                    if (!$scope.isCreditIncentiveOption()) {
                        $scope.creditOptions.apr = String($scope.creditOptions.apr);
                        return true;
                    }
                }
                return false;
            };

            $scope.showChange = function () {
                var cartAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');

                if (cartAmount >= 99) {
                    return true;
                }
                return false;
            };

            $scope.showInstallmentOption = function () {
                if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.checkoutSession.get('plan.paypal_credit') && $scope.creditOptions && $scope.creditOptions.creditType) {

                    if ($scope.creditOptions.creditType === 'INST') {
                        $scope.installmentInfo = {
                            monthlyPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.monthlyPayment, $scope.cartCurrency),
                            totalInterestAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalInterest, $scope.cartCurrency),
                            totalPaymentAmt: (0, _squid.formatCurrency)($scope.creditOptions.totalPayment, $scope.cartCurrency)
                        };
                    }
                    return true;
                } else {
                    return false;
                }
            };

            // if PPCredit & Incentive are showing in the page together with installments, we will:
            // 1. add a warning message in the top of the page as the installment option selected in cyco page
            //    is not available with PayPal incentives balance.
            // 2. hide installment options (see above method showInstallmentOptionWithoutIncentives())
            if ($scope.showInstallmentOption() && $scope.creditOptions.creditType === 'INST' && $scope.isCreditIncentiveOption()) {
                $scope.checkoutSession.message = {
                    type: 'warning',
                    msgKeys: ['offers.bmlInWalletInvalidInstallmentsMsg']
                };
            } else if ($scope.checkoutSession.message && $scope.checkoutSession.message.msgKeys && $scope.checkoutSession.message.msgKeys[0] === 'offers.bmlInWalletInvalidInstallmentsMsg') {
                // Remove error message in review page if was showing before changing payment method
                $scope.checkoutSession.message = null;
            }

            $scope.showCYCO = function () {
                $scope.checkoutSession.message = null;
                if ($scope.creditSharedInfo.getRedirectToCapeCyco()) {
                    _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true });
                } else {
                    _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
            };

            if (_angular.$window.location.search.search('atoSuccess') !== -1) {
                _logger.$logger.debug('PLANNING_ATO_SUCCESS');
                var atoMsg = _squid.$locale.content.get('memberReview.stepupAuthSuccess');

                if (atoMsg) {
                    $scope.checkoutSession.message = {
                        msgs: [atoMsg],
                        type: 'success'
                    };
                }
            }

            $scope.$on('localeChange', setInformalName);
            setInformalName();

            $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();

            if (_squid.$util.param('redirectToHermesOn3DSDecline')) {
                // check and show the 3DS decline message when the app is redirected from Xoon app
                show3DSDeclineMsg();
            }

            $scope.showAuthMsg = ['authorize', 'order'].indexOf($scope.checkoutCart.get('payment_action')) > -1 && !$scope.checkoutSession.get('plan.paypal_credit');

            if ($scope.showAuthMsg) {
                /*
                    new compliance message for AS1 / AS2 is not for US which displays LearnMore Link
                    have this scope variable set based on country
                */
                $scope.showAuthMsgLearnMore = _squid.$locale.country !== 'US' ? true : false;
            }

            $scope.showUnconfirmedUpopMsg = !!$scope.checkoutSession.unconfirmed_upop;

            $scope.useraction = $scope.checkoutAppData.useraction() && $scope.checkoutAppData.useraction().toLowerCase();

            // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
            // are not available and purchase amount is not zero.
            var noLineItemDetails = $scope.useraction !== 'commit' && $scope.checkoutCart.get('purchase.items.length', 0) === 0;

            var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments', []);
            var isCreditInWallet = false;

            if ($scope.checkoutCart.isBillingNoPurchase()) {
                isCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');
            } else {
                isCreditInWallet = fundingInstruments.find(function (fi) {
                    return fi.name === 'BILL_ME_LATER';
                });
            }

            var isPPCEligible = $scope.checkoutSession && $scope.checkoutSession.creditOffer;
            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            _logger.$logger.debug('creditInstallmentOffer ' + $scope.checkoutSession.creditInstallmentOffer + ', ' + 'creditOffer ' + $scope.checkoutSession.creditOffer + ', ' + isCreditInWallet + ', ' + isPayPalCredit);

            if ($scope.checkoutSession.creditOffer) {
                if (!_angular.$rootScope.bml) {
                    _angular.$rootScope.bml = new _bml.$BMLModel();
                }
                _angular.$rootScope.bmlApply = new _bml.$ApplyForBMLModel();
            }
            // the second button user is ineligible for PPC and has not selected to "pay with paypal"
            else if (isPayPalCredit && !isPPCEligible && !$scope.creditDataModel.payInFull && !isCapeReturn) {
                    var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country');

                    // no credit in wallet
                    if (!isCreditInWallet) {
                        $scope.checkoutSession.message = {
                            type: 'info',
                            msgKeys: ['offers.bmlIneligibleHeader', 'offers.bmlIneligibleContent']
                        };

                        _logger.$logger.info('checkout_fpti', {
                            from: 'Login',
                            to: 'Review',
                            error_type: 'second_btn_ineligible'
                        });
                    }
                    // 2nd button, cross border, user saw CYCO page -- we cannot honor any offer the user chose
                    // for LU merchants, don't show banners for eBayRM for connect scenario
                    else if ($scope.creditDataModel.isCrossBorder() && merchantCountry !== 'LU' && $scope.creditDataModel.hasSelectedCYCOOffer()) {
                            var msg = (0, _squid.$renderContent)('offers.bmlCrossBorderIneligibleContent', {
                                merchantCountry: merchantCountry
                            });
                            $scope.checkoutSession.message = {
                                msgs: [msg],
                                type: 'warning'
                            };
                        }
                }

            $scope.showSoftDescriptor = !$scope.checkoutAppData.flags.hide_soft_descriptor && $scope.checkoutCart.get('purchaseUnits.length', 0) <= 1;

            return (0, _pxp.$pxpCartAmt)($scope.checkoutAppData.get('merchant.merchant_country'), $scope.payee.get('merchant.id', ''), noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (showAmount) {
                $scope.showAmt = showAmount;
            });
        };

        var checkIfSkipReview = function checkIfSkipReview() {

            var skipReviewFlag = _squid.$util.param('skip-review'),
                oneClickEligible = $scope.checkoutSession.oneClickEligible,
                merchantId = $scope.payee.get('merchant.id'),
                merchantIds = _squid.$config.skipReviewWhitelistedMerchants || [],
                deviceMobile = _index2.$DeviceInfo.isMobile();

            if (skipReviewFlag && oneClickEligible && merchantIds.some(function (id) {
                return id === merchantId;
            }) && deviceMobile) {

                _logger.$logger.info('review_skipped');
                $scope.onPay();
            }
        };

        var shouldEnableBalance = function shouldEnableBalance(currentState) {
            var eligibility = currentState.eligibility;

            // initial eligibilty is set to null so it's essential to
            // explicitly check current eligibility is not null

            if (_sharedUtil.$SharedUtil.isBoolean(eligibility) && !eligibility) {
                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [_squid.$locale.content.get('compliance.cipIncomplete')]
                };
                _logger.$logger.info('review_page_controller_render_cip_incomplete_message');
            }
        };

        var applyNegativeBalanceStatus = function applyNegativeBalanceStatus() {
            var checkoutSession = $scope.checkoutSession;
            var negBals = checkoutSession.negBals;
            var nbrMsgContentKey = void 0;
            var tokenHash = void 0;

            if (negBals) {
                nbrMsgContentKey = 'memberReview.nbrMsg';
                tokenHash = {
                    neg_bal: (0, _squid.formatCurrency)(negBals[0].amount, negBals[0].currency_code, false),
                    merchantName: $scope.checkoutAppData.get('merchant.brand_name')
                };

                if (negBals.length > 1) {
                    nbrMsgContentKey += 'Plural';
                    tokenHash.neg_bal2 = (0, _squid.formatCurrency)(negBals[1].amount, negBals[1].currency_code, false);
                }

                checkoutSession.message = {
                    type: 'warning',
                    msgs: [(0, _squid.$renderContent)(nbrMsgContentKey, tokenHash)]
                };
            }
        };

        var applyBrPxp = function applyBrPxp() {
            if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
                var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_ryi_design;

                return (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                    $scope.ryiDesignExp = result;
                });
            }
        };

        var applyShowShippingMethod = function applyShowShippingMethod() {
            $scope.isInstantUpdateAPIFlow = $scope.checkoutCart && $scope.checkoutCart.get('instantUpdateIntegration');
            $scope.showShippingMethod = $scope.isInstantUpdateAPIFlow ? true : false;
            if (_integration.$integration.getConfig('SHOW_SHIPPING_METHOD')) {
                return setShowShippingMethodProperty();
            }
        };

        $scope.policyContentKey = function () {
            var policyContentKey = 'memberReview.viewPaypalPolicies';
            var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;
            if (buyerOptOut) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptOut';
            } else if ($scope.isOptionalVaulting()) {
                policyContentKey = 'memberReview.viewPaypalPoliciesOptIn';
            }
            _logger.$logger.info('resolved_policy_content_key_' + policyContentKey);
            return policyContentKey;
        };

        var isPPCReuseAndSelected = function isPPCReuseAndSelected() {
            var plans = $scope.checkoutSession.get('fundingOptions.instruments', null);

            if (plans && plans.filter(function (fi) {
                return fi.name === 'BILL_ME_LATER' && fi.selected;
            }).length === 1) {
                return true;
            } else {
                return false;
            }
        };

        var applyPayButtonOption = function applyPayButtonOption() {
            $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
            $scope.merchantMsg = $scope.checkoutCart.getBillingDescription();

            var isBilling = $scope.checkoutCart.isBilling();
            var merchant = $scope.checkoutAppData.merchant;
            var isWPSSubscriptionFlow = $scope.checkoutAppData.is_wps_subscription_flow();
            var isWPSAutoBillingFlow = $scope.checkoutAppData.isWpsAutobillingFlow();
            var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();

            $scope.merchantName = merchant.brand_name || merchant.merchant_name;

            // Determine whether the button type is a Pay button or Continue button
            $scope.buttonLabelIsPay = $scope.useraction === 'commit' || _integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW');

            // if the user has credit selected the button label should be not be 'pay now'
            if (isPPCReuseAndSelected()) {
                $scope.buttonLabelIsPay = undefined;
            }

            // log paybuttonText as paynow or continue
            // irrespective of PAD, credit, etc
            _logger.$logger.info('checkout_fpti', {
                'ryp_button_text': $scope.buttonLabelIsPay ? 'paynnow_y' : 'paynnow_n'
            });

            // show shipping address based on merchant passed in parameter
            $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required && $scope.checkoutSession.shipping);

            // review page 'continue' or 'pay now' button logic to return the button text
            $scope.payButtonText = function () {
                var buyerOptOut = $scope.isOptionalVaulting() && $scope.vault.checked === false;

                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if (_squid.$locale.country === 'DE') {
                        return _squid.$locale.content.get('memberReview.bmlContinueToApplication');
                    }
                    return _squid.$locale.content.get('applyForBml.bmlApplyHeadline');
                }

                if ($scope.isDEInstallmentsApproved()) {
                    return _squid.$locale.content.get('memberReview.bmlBindingApply');
                }

                if (isBilling && !buyerOptOut) {
                    if ($scope.buttonLabelIsPay) {
                        if (isWPSSubscriptionFlow || isSubscriptionsV1 || isWPSAutoBillingFlow) {
                            return _squid.$locale.content.get('memberReview.agreeAndSubscribeLabel');
                        }
                        return _squid.$locale.content.get('memberReview.agreeAndPayLabel');
                    } else {
                        return _squid.$locale.content.get('memberReview.agreeAndContinueLabel');
                    }
                } else if (getPadToggleStatus() === 'ON') {
                    return _squid.$locale.content.get('memberReview.padLabel');
                } else if ($scope.buttonLabelIsPay) {
                    if ($scope.checkoutSession.unconfirmed_upop) {
                        return _squid.$locale.content.get('memberReview.pay');
                    } else {
                        $scope.payButton = 'paynnow_y';
                        return _squid.$locale.content.get('memberReview.payLabel');
                    }
                } else {
                    $scope.payButton = 'paynnow_n';
                    return _squid.$locale.content.get('memberReview.continueLabel');
                }
            };

            $scope.onRedeemGC = function () {
                throw new _squid.$FallbackError({
                    reason: 'redeem_coupon_feature_not_supported',
                    product: 'ux'
                });
            };

            // Check if processor decline message needs to be set
            setProcessorDeclineMessage($scope.checkoutSession);

            $scope.promotion = {
                type: null,
                name: ''
            };

            var plccOffer = $scope.checkoutSession && $scope.checkoutSession.plccOffer;

            if (plccOffer) {
                $scope.promotion.logoUrl = plccOffer.product_logo;
                $scope.promotion.name = plccOffer.product_name;
            }

            $scope.onFBBANotNow = function () {
                var _$scope$checkoutSessi4 = $scope.checkoutSession.payer;
                _$scope$checkoutSessi4 = _$scope$checkoutSessi4 === undefined ? {} : _$scope$checkoutSessi4;
                var payerId = _$scope$checkoutSessi4.id;

                var isUnchecked = _squid.$util.sessionStorageEnabled() && window.sessionStorage.getItem('checkboxPluginState') === 'unchecked';

                _logger.$logger.info('checkout_fpti', {
                    buyer_country: _squid.$locale.country,
                    buyer_id: payerId,
                    context_id: $scope.token,
                    design: 'fbmessenger',
                    from: 'BILLING_AGREEMENT',
                    to: 'process_billing_agreement',
                    eligibility_reason: isUnchecked ? 'checkbox_plugin_unchecked' : 'checkbox_plugin_checked',
                    click_source: 'not_now'
                });

                window.xchild.close();

                if (experience.autoBA) {
                    window.top.location.replace('fbiab://paypal/abort');
                }
            };

            $scope.onPay = function (result) {

                _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T4' });

                // If back clicked in browser and lands on review, we need to do the clear cvv contigency
                $scope.resetCVVContigency({ flow: 'browser_back' });

                // Track NMJ variations.
                var payEventName = void 0;

                if ($scope.isNmjDesign1) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design1_page';
                } else if ($scope.isNmjDesign2) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design2_page';
                } else if ($scope.isNmjDesign3) {
                    payEventName = 'member_ryi_onPayVariant_nmj_design3_page';
                } else {
                    payEventName = 'member_ryi_onPayVariant_control';
                }

                _logger.$logger.info(payEventName);

                if ($scope.showMissingPickupOptionMessage || $scope.showMissingShippingOptionMessage) {
                    return;
                }

                if (!isValidPinSetup()) {
                    $scope.topupError = true;
                    _logger.$logger.debug('pin_missing');
                    _uiRouter.$state.go('checkout.pinSetup');
                    return;
                }

                if ($scope.checkoutSession.installments && $scope.checkoutSession.installments.length > 1 && !$scope.checkoutSession.selectedInstallmentData) {
                    $scope.installmentNotSelected = true;
                    return;
                }

                if ($scope.isInstantUpdateAPIFlow && !$scope.instantUpdateFeature.shippingRegionSupported) {
                    return;
                }

                // Determine whether or not to prevent going forward based on the status of the onShippingChange callback
                if ($scope.shippingChangeFeature && $scope.shippingChangeFeature.status) {
                    switch ($scope.shippingChangeFeature.status) {
                        case $scope.shippingChangeFeature.enums.LOADING:
                        case $scope.shippingChangeFeature.enums.REJECTED:
                        case $scope.shippingChangeFeature.enums.FAILED:
                            return;
                        default:
                    }
                }

                if ((0, _squid.$feature)('creditInstallmentOffers') && isPPCReuseAndSelected() && !($scope.creditOptions && $scope.creditOptions.creditType) && $scope.creditSharedInfo.hasInstallmentOffers()) {
                    // customer is elgibile for installments and not selected an offer yet.
                    // if they fall under the treatment and they are no a return back from cape they will see the new cyco page
                    // else they will go to the CYCO page in hermes
                    return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                }
                // "Paying" by applying for PPC
                if ($scope.selectedmethod && $scope.selectedmethod.planId === 'applyForPPCRadio') {
                    if ((0, _squid.$feature)('creditInstallmentOffers') && $scope.installment && $scope.installment.installmentOptionsPresent) {
                        return $scope.creditSharedInfo.getRedirectToCapeCyco() ? _uiRouter.$state.go('checkout.redirectToCape', { showCapeCyco: true }) : _uiRouter.$state.go('checkout.chooseCreditOffer');
                    } else if (_squid.$locale.country === 'DE' && $scope.creditSharedInfo.hasInstallmentOffers() && $scope.creditSharedInfo.hasInstallmentOfferFinancingDetails()) {
                        return _uiRouter.$state.go('checkout.redirectToCape', { financing_option: $scope.creditSharedInfo.getInstallmentOfferFinancingDetails() });
                    } else {
                        return _uiRouter.$state.go('checkout.redirectToCape');
                    }
                }

                // users are able to trigger multiple preAuthorize calls, disabling the button after first click to prevent that
                $scope.onPayButtonDisabled = true;
                return checkForAddressNormalization()['catch'](function (error) {
                    if (error instanceof _squid.$ShortCircuit) {
                        throw error;
                    }

                    _logger.$logger.error('checkForAddressNormalization_error', error);
                }).then(function () {
                    var padToggleStatus = getPadToggleStatus();

                    if (padToggleStatus === 'ON') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOnSubmit'
                        });
                    } else if (padToggleStatus === 'OFF') {
                        _logger.$logger.info('checkout_fpti', {
                            'pad_toggle_status': 'padToggleOffSubmit'
                        });
                    }

                    /**
                     * Call updateFS so that if user has made a change in the multiple FI on RYI variant, we select their instrument before doing other logic
                     * Call patchCvv first, if error, need buyers to input again
                     * Call to set Sticky Funding Instrument for Billing Agreement.
                     * We have to ensure the sticky call happens before authorize due to symphony spec.
                     * We need to wait for the response from updateAddressAsPreferred before calling authorize                 */

                    var tokenizationPreAuthorizeError = void 0;

                    return updateFS()
                    // Make PAPS patch calls sequentially. Concurrent patch calls are currently not supported
                    .then(function () {
                        return checkJSV4PaymentDetails();
                    }).then(function () {
                        return _tokenizedFactory.$TokenizedFactory.tokenizedOnPayCalls($scope.checkoutCart, $scope.checkoutSession, $scope.tokenizedWalletInfoModel, $scope.walletPinModel);
                    }).then(function () {
                        setCvvData();
                        return _fiApis.$fiApis.patchCvv($scope.checkoutSession);
                    }).then(function () {
                        return setStickyInstrument();
                    })
                    // Other calls that won't affect the checkout session. Multiple patch calls to PAPS should not be made here
                    .then(function () {
                        return _angular.$q.all([updateAddressAsPreferred(), // This is a patch call to PAPS
                        setWalletTopupPreferences(), linkAuthConsent(), $scope.actions.updatePreferredFi(_logger.$logger), donationAuthorize()])['catch'](function (err) {
                            // should we have more elaborate error handling here?
                            if ($scope.checkoutCart.isWalletTokenization()) {
                                if (err && err.message === 'WALLET_PREFERENCE_SET_ERROR') {
                                    tokenizationPreAuthorizeError = err;
                                }
                            }
                            _logger.$logger.error('onPay() error', err);
                        })['finally'](function () {
                            if (tokenizationPreAuthorizeError) {
                                var code = 'ANDROID_PAY_SET_WALLET_PREFERENCE_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                            } else {
                                return authorize();
                            }
                        });
                    }, function (err) {
                        if ($scope.hasShippingOptions() && err.message === 'IXO_CANNOT_CHECKOUT_WITHOUT_SHIPPING_SELECTION') {
                            return;
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            if (err && err.message === 'ISSUANCE_PIN_SERVICE_ERROR') {
                                var code = 'ANDROID_PAY_SET_PIN_ERROR';
                                code = window.btoa(code);
                                _uiRouter.$state.go('checkout.genericError', { code: code });
                                return;
                            }
                        }
                        _logger.$logger.error('onPay() patchCvv error', err);
                    })['finally'](function () {
                        $scope.onPayButtonDisabled = false;
                    });
                });
            };

            $scope.cancelCreditApplication = function () {
                var baseUrl = window.location.href.split('?')[0];
                var params = _squid.$util.params();

                // Remove CAPE return parameters as the user has
                delete params.success;
                delete params.key;

                _squid.$util.redirect(_squid.$util.buildURL(baseUrl, params));
            };

            /* This is used for a BML 'popup' that opens covering the whole review page,
             hiding the rest of the review page when its open. */
            $scope.bmlPopupOpen = false;
            $scope.showBmlPopup = function () {
                $scope.bmlPopupOpen = true;
            };
            $scope.hideBmlPopup = function () {
                $scope.bmlPopupOpen = false;
            };
        };

        var checkForAddressNormalization = function checkForAddressNormalization() {
            // before any address normalization action , check whether it is required to do so
            // if buyer country and shipping address country different , then don't try to normalize that
            // address normalization enabled for BR and US buyers and now force only if shipping address also matches
            $scope.shippingAddress = $scope.checkoutSession.get('shipping');
            var country = $scope.shippingAddress && $scope.shippingAddress.country;
            if (_squid.$locale.country === country) {
                if (!$scope.AddressNormzalizationDone && $scope.checkoutAppData.get('flags.allow_change_shipping', false) && (0, _squid.$feature)('shippingAddressNormalization')) {
                    if ((0, _squid.$feature)('addressNormalizationEdit') && $scope.shippingAddress) {
                        return _factory6.$AddressNormalizationFactory.getAddressNormalizationElmoResult(country).then(function (treatment) {
                            if (treatment && $scope.shippingAddress.normalization_status === 'UNKNOWN') {
                                $scope.strictAddressNormalization = false;
                                _uiRouter.$state.go('checkout.review.sidebar.addressNormalizationEdit');
                                return _squid.$promise.shortCircuit();
                            } else {
                                return _angular.$q.when();
                            }
                        });
                    } else if ($scope.checkoutSession.get('shipping.normalization_status') === 'UNKNOWN') {
                        _uiRouter.$state.go('checkout.review.sidebar.updateShipping');
                        return _squid.$promise.shortCircuit();
                    }
                }
            }
            return _angular.$q.when();
        };

        // This function is sent to Address Normalziation process as callback
        // when Address normalization proccess finishes it'll redirect back to
        // here, review page.
        $scope.onAddressNormalized = function () {
            _uiRouter.$state.go('checkout.review').then(function () {
                $scope.AddressNormzalizationDone = true;
                $scope.onPay();
            });
        };

        var checkForReviewLaterText = function checkForReviewLaterText() {
            $scope.showReviewLaterText = true;

            if ($scope.checkoutCart.isSubscriptionsV1()) {
                $scope.showReviewLaterText = $scope.useraction === 'commit' ? false : true;
                return;
            }
            // only get pxp if buttonlabel is not pay and for billingWithOutPurchase
            if ($scope.useraction !== 'commit' && !_integration.$integration.getConfig('SHOW_PAY_NOW_LABEL_ON_REVIEW') && $scope.checkoutCart.isBillingNoPurchase()) {
                _logger.$logger.info('billing_no_purchase_use_case');
                $scope.showReviewLaterText = false;
            }
        };

        var initBillingNoPurchasePlans = function initBillingNoPurchasePlans() {
            var isBillingNoPurchase = $scope.checkoutCart && $scope.checkoutCart.isBillingNoPurchase();

            $scope.plans = isBillingNoPurchase ? $scope.checkoutSession.get('futurePaymentInstruments') : $scope.checkoutSession.getPlanList();
        };

        var showBillingMessage = function showBillingMessage() {
            var merchant = $scope.checkoutAppData.get('merchant');
            var merchantName = merchant.brand_name || merchant.merchant_name || 'Merchant';

            $scope.showMessage = true;
            var contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant', { merchantName: merchantName });

            if ($scope.checkoutCart.isConsumerCountry('IN') && $scope.checkoutCart.isBilling()) {
                if ($scope.checkoutCart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow() || $scope.checkoutCart.isSubscriptionsV1()) {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rp', { merchantName: merchantName });
                } else {
                    contentDataKey = (0, _squid.$renderContent)('memberReview.billingMerchant_rt', { merchantName: merchantName });
                }

                $scope.checkoutSession.message = {
                    type: 'info',
                    msgs: [contentDataKey]
                };
            }
        };

        var showMoreFiInit = function showMoreFiInit() {
            var showMoreFiEligibility = _factory4.$ShowMoreFiFactory.decideEligibility({ plans: $scope.plans });

            if (showMoreFiEligibility) {
                showMoreFiEligibility.then(function () {
                    _factory4.$ShowMoreFiFactory.init($scope.plans);
                });
            }
        };

        // TODO: please talk with AuthRate team on `xo_hermes_preferred_expired_msg_review_page` pxp when
        // they decide to turn the experiement on next year!
        // https://engineering.paypalcorp.com/pxptool/history?exptId=3935
        // const showExpiredMsgInit = () => {
        //     $scope.showExpiredMsg = $ExpiredMsgFactory.showExpiredMsg($scope.isNmj, $scope.checkoutSession);
        //     if ($scope.showExpiredMsg) {
        //         $ExpiredMsgFactory.getPreferredExpiredPxpResult().then(result => {
        //             $scope.isNmjexpired = result === 'xo_hermes_preferred_expired_msg_review_page_nmj_treatment' ? true : false;
        //             $scope.preferredExpired = $scope.checkoutSession.getDisallowedPreferred();
        //         });
        //     }
        // };

        // lazy load some of the most popular routes to increase loading time
        var preloadCodeSplitRoutes = function preloadCodeSplitRoutes() {
            if (_squid.$meta.codeSplitting) {
                var routes = [];

                if (_integration.$integration.isFlow('WPS')) {
                    routes.push.apply(routes, [import('pages/xo-pay/route'), // eslint-disable-line
                    import('xo-page-components/src/done/route') // eslint-disable-line
                    ]);
                }

                routes.push.apply(routes, [import('pages/xo-sidebar/route')]);

                // preload checkout.genericMessage route which is shown when transaction is completed
                // on devices. So basically user will see `Thanks for using PayPal!` and `You can close this tab at any time.`
                // and at the same time there will be client side redirect
                // https://github.paypal.com/Checkout/xo-return-to-merchant/blob/master/dist/util.js#L44
                // May help reduce noise in case of code split when it's trying to first download the js chunk and then make redirect
                // which may take longer than usual
                if (_index2.$DeviceInfo.isDevice()) {
                    routes.push(import('pages/xo-generic-message/route'));
                }

                Promise.all(routes)['catch'](function (err) {
                    _logger.$logger.info('code_split_review_routes_preload_failed', {
                        error: err && err.message
                    });
                });
            }
        };

        var isUSCrossCurrency = function isUSCrossCurrency() {
            if ($scope.checkoutCart && $scope.checkoutCart.grossTotalAmount && $scope.checkoutCart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                return true;
            }
            return false;
        };

        var handleUnsupportUSCrossCurrency = function handleUnsupportUSCrossCurrency() {
            if ($scope.checkoutSession.fundingOptions && $scope.checkoutSession.fundingOptions.plans) {
                var plans = $scope.checkoutSession.fundingOptions.plans.filter(function (plan) {
                    return plan.primaryFs.name !== 'BILL_ME_LATER';
                });
                if (isUSCrossCurrency() && !plans.length) {
                    _uiRouter.$state.go('checkout.pageAddCard.addCardFlow.addCard', { message: 'NEED_CREDIT_CARD', cause: 'cpa' });
                } else if (isUSCrossCurrency()) {
                    doPlanSelection(plans[0].planId);
                }
            }
        };

        _logger.$logger.debug('xo_credit_banner_monitoring', { tag: 'T0' });

        /**
         * This promise chain renders critical content in the page. Avoid
         * the temptation to tack on another `.then` to this promise chain.
         *
         * If you are making a critical network request, consider putting
         * function inside the `$q.all` array so it can be run in parallel
         * and not slow down page rendering.
         *
         * If your function requires values available on `$scope` after
         * the critical functions in `$q.all` are complete, put your
         * function in the following `.then` block.
         *
         * Otherwise, your function can likely go somewhere else.
         */
        populateScope().then(function () {
            stickyCTA();
            _factory3.$RewardsCheckboxFactory.buildCache();
            // applyCreditOptions could potentially redirect out of the RYI.
            // Seperate it out from the rest of the pack to avoid unnecessary code execution
            handleUnsupportUSCrossCurrency();
            applyCreditOptions();
            triggerPersonalizedBanner();
            applyMerchantName();
            applyPayButtonOption();
            checkIfSkipReview();
            applyChoiceExperimentVariant();
            applyNegativeBalanceStatus();
            applyKmliUpsellEligibility();
            applyShowShippingMethod();
            applyInvoicingRegEDetails();
            showLanguageToggleForRTR();
            initAndCallOnShippingChange();
            checkForReviewLaterText();
            initBillingNoPurchasePlans();
            showBillingMessage();
            applyBrPxp();
            initializePadToggleSupport();
            showGAC();
            _factory2.$NoBalanceFactory.decideEligibility();
            prepareTokenizedWallet();
            applyNewMemberVariant().then(function () {
                // TODO: see comment from above in regards to run this pxp again
                // showExpiredMsgInit();
            });
            showMoreFiInit();
            logSessionDetails();
            preloadCodeSplitRoutes();

            //  To show cvv box even though the cvvData already resolved.
            $scope.resetCVVContigency({ flow: 'page_refresh' });
            checkExperienceElmoTreatment();

            // Decide whether to display CIP_INCOMPLETE (AU only) message and disable PayPal balance
            // as a valid funding instrument
            _balance.$BalanceEligibilityFactory.init({ checkoutSession: $scope.checkoutSession }).then(function (currentState) {
                return shouldEnableBalance(currentState);
            });
        })['finally'](function () {
            if (window.appPerformanceEvents) {
                // TimeToFullyRender: The moment client is ready to receive with all data for the user.
                // Should be the last promise on the page
                // to be triggered after all data loads
                window.appPerformanceEvents.TimeToFullyRender = parseInt(window.performance.now(), 10);
                _logger.$logger.info('APP_PERFORMANCE_EVENTS', window.appPerformanceEvents);
            }
        });
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
        (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');

        $scope.onComplete = function (params) {
            if (params) {
                _logger.$logger.debug('ryi_optin_isKmliSet_' + params.isKmliSet);
                if (params.isKmliSet) {
                    $scope.optin_toggle.setValue(true);
                }
            }
            _uiRouter.$state.go('checkout.review');
        };

        $scope.propValueObj = {};
        if ((0, _squid.$feature)('propValue')) {
            $scope.propValueObj.propHeader = 'memberReview.propHead';
            $scope.propValueObj.propVal = 'memberReview.propVal';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_shield_bags.png';
        } else {
            $scope.propValueObj.propHeader = 'login.propHeadAlt';
            $scope.propValueObj.propVal = 'login.propValAlt';
            $scope.propValueObj.propImage = 'https://www.paypalobjects.com/images/checkout/hermes/scr_vp_fprd_wallet_card_v3.png';
        }
    }]
});

angular.value("$xoReviewPageComponent", $xoReviewPageComponent);
_uiRouter.$state;

_index.$miniBrowser;

_logger.$logger;

_integration.$integration;

_index2.$DeviceInfo;

_ul.$ul;

_pxp.$pxpCartAmt;

_marketingoffer.$fireMORSBeacon;

_angular.$q;

_angular.$rootScope;

_angular.$timeout;

_angular.$window;

_angular.noop;

_kmliUpsell.$KmliUpsell;

_utils.getSelectedPlan;

_utils.getInstrumentID;

_squid.$Class;

_squid.$Component;

_squid.$config;

_squid.$FallbackError;

_squid.$feature;

_squid.$featureCountries;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$pxpFactors;

_squid.$renderContent;

_squid.$util;

_squid.formatCurrency;

_squid.formatNameInformal;

_squid.$promise;

_squid.$ShortCircuit;

_squid.$elmo;

_squid.$event;

_thirdPartyInfo.thirdPartyExperience;

_auth.$AuthModel;

_fiApis.$fiApis;

_eligibility.$stickyCTA;

_choice.$ChoiceEligibility;

_fiMessages.$fiMessages;

_donation.$GiveAtCheckoutModel;

_bml.$ApplyForBMLModel;

_bml.$BMLModel;

_credit.$CreditDataModel;

_credit.$CreditInstallmentModel;

_credit.$CreditSharedInfoModel;

_fi.$AddCardModel;

_fi.$CardModel;

_fi.$PreferredFi;

_fi.$WalletPreferences;

_app.$TokenizedFundingCapabilitiesModel;

_app.$TokenizedWalletInfoModel;

_app.$TokenizedWalletPinModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_marketingoffer2.$MemberSegmentModel;

_newMember.$NewMemberEligibility;

_shippingMethod.$ShippingRuleSummaryModel;

_user.$AuthConsentModel;

_user.$UserEligibleToHoldBalanceModel;

_factory.$GiveAtCheckoutFactory;

_factory2.$NoBalanceFactory;

_factory3.$RewardsCheckboxFactory;

_factory4.$ShowMoreFiFactory;

_factory5.$AddCardFactory;

_factory6.$AddressNormalizationFactory;

_cardartInstrument.$CardArtInstrument;

_factory7.$BalanceFactory;

_factory8.$PADFactory;

_tokenizedFactory.$TokenizedFactory;

_shippingChangeFeature.createShippingChangeFeature;

_shippingChangeFeature.hasOnShippingChangeCallback;

_xoShippingOptions.getShippingOptions;

_xoShippingOptions.selectShippingOption;

_xoShippingOptions.getSelectedShippingOption;

_xoShippingOptions.$xoShippingOptions; // eslint-disable-line no-unused-vars;

_sharedUtil.$SharedUtil;

_balance.$BalanceEligibilityFactory;

_qs.parse;

_qs.stringify;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/directive.js
// module id = ./pages/xo-review/directive.js
// module chunks = main-code-split